var map = {
	"../../../../../../../app/Customer/modules/transactions/tusale/tudealhistory/redeemhistory/tusale.module": [
		"./src/app/Customer/modules/transactions/tusale/tudealhistory/redeemhistory/tusale.module.ts",
		"app-Customer-modules-transactions-tusale-tudealhistory-redeemhistory-tusale-module"
	],
	"../../../../../../../app/Customer/modules/transactions/tusale/tudealhistory/tupayments/tupayments.module": [
		"./src/app/Customer/modules/transactions/tusale/tudealhistory/tupayments/tupayments.module.ts",
		"app-Customer-modules-transactions-tusale-tudealhistory-tupayments-tupayments-module"
	],
	"../../../../../app/Customer/modules/transactions/tusale/loanhistory/loanhistory.module": [
		"./src/app/Customer/modules/transactions/tusale/loanhistory/loanhistory.module.ts",
		"app-Customer-modules-transactions-tusale-loanhistory-loanhistory-module"
	],
	"../../../../../app/Customer/modules/transactions/tusale/tudealhistory/dealtransaction/dealtransaction.module": [
		"./src/app/Customer/modules/transactions/tusale/tudealhistory/dealtransaction/dealtransaction.module.ts",
		"app-Customer-modules-transactions-tusale-tudealhistory-dealtransaction-dealtransaction-module"
	],
	"../../../../../modules/accounts/tuconsole/merchants/bnplconfigurations/bnplconfigurations.module": [
		"./src/app/modules/accounts/tuconsole/merchants/bnplconfigurations/bnplconfigurations.module.ts",
		"modules-accounts-tuconsole-merchants-bnplconfigurations-bnplconfigurations-module"
	],
	"../../../../../modules/accounts/tuconsole/merchants/tuconfigurations/tuconfigurations.module": [
		"./src/app/modules/accounts/tuconsole/merchants/tuconfigurations/tuconfigurations.module.ts",
		"modules-accounts-tuconsole-merchants-tuconfigurations-tuconfigurations-module"
	],
	"../../../../../modules/accounts/tuconsole/topup/topup.module": [
		"./src/app/modules/accounts/tuconsole/topup/topup.module.ts",
		"accounts-tuconsole-topup-topup-module"
	],
	"../../../../Acquirer/account/tustores/manager/tustores.module": [
		"./src/app/Acquirer/account/tustores/manager/tustores.module.ts",
		"Acquirer-account-tustores-manager-tustores-module"
	],
	"../../../../Acquirer/account/tustores/merchant/tustores.module": [
		"./src/app/Acquirer/account/tustores/merchant/tustores.module.ts",
		"default~Acquirer-BranchDivision-EditBranch-EditBranch-module~Acquirer-account-tustores-merchant-tust~edebb253",
		"Acquirer-account-tustores-merchant-tustores-module"
	],
	"../../../../Acquirer/account/tuteams/manager/tuteams.module": [
		"./src/app/Acquirer/account/tuteams/manager/tuteams.module.ts",
		"Acquirer-account-tuteams-manager-tuteams-module"
	],
	"../../../../Acquirer/account/tuterminals/merchant/tuterminals.module": [
		"./src/app/Acquirer/account/tuterminals/merchant/tuterminals.module.ts",
		"Acquirer-account-tuterminals-merchant-tuterminals-module"
	],
	"../../../../Acquirer/accountdetails/tutargethistory/tutargethistory.module": [
		"./src/app/Acquirer/accountdetails/tutargethistory/tutargethistory.module.ts",
		"Acquirer-accountdetails-tutargethistory-tutargethistory-module"
	],
	"../../../../Acquirer/campaigns/sales/tusale.module": [
		"./src/app/Acquirer/campaigns/sales/tusale.module.ts",
		"Acquirer-campaigns-sales-tusale-module"
	],
	"../../../../Acquirer/dashboards/manager/acquirer/dashboard.module": [
		"./src/app/Acquirer/dashboards/manager/acquirer/dashboard.module.ts",
		"Acquirer-dashboards-manager-acquirer-dashboard-module"
	],
	"../../../../Acquirer/dashboards/merchant/acquirer/dashboard.module": [
		"./src/app/Acquirer/dashboards/merchant/acquirer/dashboard.module.ts",
		"Acquirer-dashboards-merchant-acquirer-dashboard-module"
	],
	"../../../../Acquirer/dashboards/terminal/acquirer/dashboard.module": [
		"./src/app/Acquirer/dashboards/terminal/acquirer/dashboard.module.ts",
		"Acquirer-dashboards-terminal-acquirer-dashboard-module"
	],
	"../../../../Acquirer/transactions/tusale/merchant/acquirer/tusale.module": [
		"./src/app/Acquirer/transactions/tusale/merchant/acquirer/tusale.module.ts",
		"Acquirer-transactions-tusale-merchant-acquirer-tusale-module"
	],
	"../../../../Acquirer/transactions/tusale/store/tusale.module": [
		"./src/app/Acquirer/transactions/tusale/store/tusale.module.ts",
		"Acquirer-transactions-tusale-store-tusale-module"
	],
	"../../../../Acquirer/transactions/tusale/terminal/acquirer/tusale.module": [
		"./src/app/Acquirer/transactions/tusale/terminal/acquirer/tusale.module.ts",
		"Acquirer-transactions-tusale-terminal-acquirer-tusale-module"
	],
	"../../../../accounts/tuconsole/cashout/cashout.module": [
		"./src/app/modules/accounts/tuconsole/cashout/cashout.module.ts",
		"accounts-tuconsole-cashout-cashout-module"
	],
	"../../../../accounts/tuconsole/rewardpercentage/turewardpercentage.module": [
		"./src/app/modules/accounts/tuconsole/rewardpercentage/turewardpercentage.module.ts",
		"default~accounts-tuconsole-rewardpercentage-turewardpercentage-module~tumerchant-tumerchantdetails-t~5b0b1961",
		"accounts-tuconsole-rewardpercentage-turewardpercentage-module"
	],
	"../../../../accounts/tuconsole/subaccounts/tusubaccounts.module": [
		"./src/app/modules/accounts/tuconsole/subaccounts/tusubaccounts.module.ts",
		"accounts-tuconsole-subaccounts-tusubaccounts-module"
	],
	"../../../../accounts/tuconsole/topup/topup.module": [
		"./src/app/modules/accounts/tuconsole/topup/topup.module.ts",
		"accounts-tuconsole-topup-topup-module"
	],
	"../../../../accounts/tuconsole/wallate/wallate.module": [
		"./src/app/modules/accounts/tuconsole/wallate/wallate.module.ts",
		"accounts-tuconsole-wallate-wallate-module"
	],
	"../../../../merchant/giftcard/Balance/tusale.module": [
		"./src/app/merchant/giftcard/Balance/tusale.module.ts",
		"merchant-giftcard-Balance-tusale-module"
	],
	"../../../../merchant/giftcard/Redeemed/tusale.module": [
		"./src/app/merchant/giftcard/Redeemed/tusale.module.ts",
		"merchant-giftcard-Redeemed-tusale-module"
	],
	"../../../../merchant/giftcard/Reward/tusale.module": [
		"./src/app/merchant/giftcard/Reward/tusale.module.ts",
		"merchant-giftcard-Reward-tusale-module"
	],
	"../../../../merchant/giftcard/overview/tugiftcard.module": [
		"./src/app/merchant/giftcard/overview/tugiftcard.module.ts",
		"merchant-giftcard-overview-tugiftcard-module"
	],
	"../../../../modules/accounts/tuconsole/administration/dailyreconciliation/dailyreconciliation.module": [
		"./src/app/modules/accounts/tuconsole/administration/dailyreconciliation/dailyreconciliation.module.ts",
		"modules-accounts-tuconsole-administration-dailyreconciliation-dailyreconciliation-module"
	],
	"../../../../modules/accounts/tuconsole/bankreconciliation/bank.module": [
		"./src/app/modules/accounts/tuconsole/bankreconciliation/bank.module.ts",
		"modules-accounts-tuconsole-bankreconciliation-bank-module"
	],
	"../../../../modules/accounts/tuconsole/cashiers/Store/tucashiers.module": [
		"./src/app/modules/accounts/tuconsole/cashiers/Store/tucashiers.module.ts",
		"modules-accounts-tuconsole-cashiers-Store-tucashiers-module"
	],
	"../../../../modules/accounts/tuconsole/cashiers/tucashiers.module": [
		"./src/app/modules/accounts/tuconsole/cashiers/tucashiers.module.ts",
		"accounts-tuconsole-cashiers-tucashiers-module"
	],
	"../../../../modules/accounts/tuconsole/merchants/tuconfigurations/tuconfigurations.module": [
		"./src/app/modules/accounts/tuconsole/merchants/tuconfigurations/tuconfigurations.module.ts",
		"modules-accounts-tuconsole-merchants-tuconfigurations-tuconfigurations-module"
	],
	"../../../../modules/accounts/tuconsole/stores/tustores.module": [
		"./src/app/modules/accounts/tuconsole/stores/tustores.module.ts",
		"accounts-tuconsole-stores-tustores-module"
	],
	"../../../../modules/accounts/tuconsole/subaccounts/tusubaccounts.module": [
		"./src/app/modules/accounts/tuconsole/subaccounts/tusubaccounts.module.ts",
		"accounts-tuconsole-subaccounts-tusubaccounts-module"
	],
	"../../../../modules/accounts/tuconsole/tuterminals/cashier/tuterminals.module": [
		"./src/app/modules/accounts/tuconsole/tuterminals/cashier/tuterminals.module.ts",
		"modules-accounts-tuconsole-tuterminals-cashier-tuterminals-module"
	],
	"../../../../modules/accounts/tuconsole/tuterminals/merchant/tuterminals.module": [
		"./src/app/modules/accounts/tuconsole/tuterminals/merchant/tuterminals.module.ts",
		"accounts-tuconsole-tuterminals-merchant-tuterminals-module"
	],
	"../../../../modules/accounts/tuconsole/tuterminals/store/tuterminals.module": [
		"./src/app/modules/accounts/tuconsole/tuterminals/store/tuterminals.module.ts",
		"modules-accounts-tuconsole-tuterminals-store-tuterminals-module"
	],
	"../../../../modules/dashboards/Customer-Overview/overview.module": [
		"./src/app/Customer/modules/dashboards/Customer-Overview/overview.module.ts",
		"modules-dashboards-Customer-Overview-overview-module"
	],
	"../../../../modules/dashboards/Customer-rewards/rewards.module": [
		"./src/app/Customer/modules/dashboards/Customer-rewards/rewards.module.ts",
		"modules-dashboards-Customer-rewards-rewards-module"
	],
	"../../../../modules/dashboards/loyality/campaigns/tucampaigns.module": [
		"./src/app/modules/dashboards/loyality/campaigns/tucampaigns.module.ts",
		"modules-dashboards-loyality-campaigns-tucampaigns-module"
	],
	"../../../../modules/dashboards/loyality/customers/tucustomers.module": [
		"./src/app/modules/dashboards/loyality/customers/tucustomers.module.ts",
		"modules-dashboards-loyality-customers-tucustomers-module"
	],
	"../../../../modules/dashboards/loyality/overview/dashboard.module": [
		"./src/app/modules/dashboards/loyality/overview/dashboard.module.ts",
		"modules-dashboards-loyality-overview-dashboard-module"
	],
	"../../../../modules/dashboards/loyality/visits/dashboard.module": [
		"./src/app/modules/dashboards/loyality/visits/dashboard.module.ts",
		"modules-dashboards-loyality-visits-dashboard-module"
	],
	"../../../../modules/dashboards/merchant/dashboard.module": [
		"./src/app/modules/dashboards/merchant/dashboard.module.ts",
		"modules-dashboards-merchant-dashboard-module"
	],
	"../../../../modules/dashboards/merchant/downloads.module": [
		"./src/app/modules/dashboards/merchant/downloads.module.ts",
		"modules-dashboards-merchant-downloads-module"
	],
	"../../../../modules/dashboards/mybuisness/tusalestrends/tusalestrends.module": [
		"./src/app/modules/dashboards/mybuisness/tusalestrends/tusalestrends.module.ts",
		"modules-dashboards-mybuisness-tusalestrends-tusalestrends-module"
	],
	"../../../../modules/dashboards/mybuisness/tusalesummary/tusalesummary.module": [
		"./src/app/modules/dashboards/mybuisness/tusalesummary/tusalesummary.module.ts",
		"modules-dashboards-mybuisness-tusalesummary-tusalesummary-module"
	],
	"../../../../modules/deals/tuadddeals/tuadddeals.module": [
		"./src/app/modules/deals/tuadddeals/tuadddeals.module.ts",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~bnpl-bnpl-module~bnploverview-bnploverview~75215596",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~bnpl-bnpl-module~bnploverview-bnploverview~de2dac75",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~modules-deals-tuadddeals-tuadddeals-module~b9019ce1",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~modules-deals-tuadddeals-tuadddeals-module~81cb151d",
		"default~modules-deals-tuadddeals-tuadddeals-module~panel-console-deals-tuadddeal-tuadddeal-module~pa~8063d5f9",
		"modules-deals-tuadddeals-tuadddeals-module"
	],
	"../../../../modules/deals/tudeal/tudeal.module": [
		"./src/app/modules/deals/tudeal/tudeal.module.ts",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~bnpl-bnpl-module~bnploverview-bnploverview~75215596",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~bnpl-bnpl-module~bnploverview-bnploverview~de2dac75",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~modules-deals-tuadddeals-tuadddeals-module~b9019ce1",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~modules-deals-tuadddeals-tuadddeals-module~81cb151d",
		"default~modules-deals-tudeal-tudeal-module~panel-console-deals-tudeal-tudeal-module",
		"modules-deals-tudeal-tudeal-module"
	],
	"../../../../modules/deals/tudeals/tudeals.module": [
		"./src/app/modules/deals/tudeals/tudeals.module.ts",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~bnpl-bnpl-module~bnploverview-bnploverview~75215596",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~bnpl-bnpl-module~bnploverview-bnploverview~de2dac75",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~modules-deals-tuadddeals-tuadddeals-module~b9019ce1",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~modules-deals-tuadddeals-tuadddeals-module~81cb151d",
		"modules-deals-tudeals-tudeals-module"
	],
	"../../../../modules/deals/tudealspurchaseoverview/tuoverview.module": [
		"./src/app/modules/deals/tudealspurchaseoverview/tuoverview.module.ts",
		"modules-deals-tudealspurchaseoverview-tuoverview-module"
	],
	"../../../../modules/transactions/tusale/Pendingtransaction/merchant/pendingtransaction/pendingtransaction.module": [
		"./src/app/modules/transactions/tusale/Pendingtransaction/merchant/pendingtransaction/pendingtransaction.module.ts",
		"modules-transactions-tusale-Pendingtransaction-merchant-pendingtransaction-pendingtransaction-module"
	],
	"../../../../modules/transactions/tusale/campaign/tusale.module": [
		"./src/app/modules/transactions/tusale/campaign/tusale.module.ts",
		"modules-transactions-tusale-campaign-tusale-module"
	],
	"../../../../modules/transactions/tusale/cashier/tusale.module": [
		"./src/app/modules/transactions/tusale/cashier/tusale.module.ts",
		"modules-transactions-tusale-cashier-tusale-module"
	],
	"../../../../modules/transactions/tusale/merchant/tusale.module": [
		"./src/app/modules/transactions/tusale/merchant/tusale.module.ts",
		"modules-transactions-tusale-merchant-tusale-module"
	],
	"../../../../modules/transactions/tusale/pendingrewardhistory/merchant/tusale.module": [
		"./src/app/modules/transactions/tusale/pendingrewardhistory/merchant/tusale.module.ts",
		"modules-transactions-tusale-pendingrewardhistory-merchant-tusale-module"
	],
	"../../../../modules/transactions/tusale/redeemhistory/merchant/tusale.module": [
		"./src/app/modules/transactions/tusale/redeemhistory/merchant/tusale.module.ts",
		"modules-transactions-tusale-redeemhistory-merchant-tusale-module"
	],
	"../../../../modules/transactions/tusale/referalhistory/tusale.module": [
		"./src/app/Customer/modules/transactions/tusale/referalhistory/tusale.module.ts",
		"modules-transactions-tusale-referalhistory-tusale-module"
	],
	"../../../../modules/transactions/tusale/rewardhistory/merchant/tusale.module": [
		"./src/app/modules/transactions/tusale/rewardhistory/merchant/tusale.module.ts",
		"modules-transactions-tusale-rewardhistory-merchant-tusale-module"
	],
	"../../../../modules/transactions/tusale/store/tusale.module": [
		"./src/app/modules/transactions/tusale/store/tusale.module.ts",
		"modules-transactions-tusale-store-tusale-module"
	],
	"../../../../modules/transactions/tusale/terminal/merchant/tusale.module": [
		"./src/app/modules/transactions/tusale/terminal/merchant/tusale.module.ts",
		"modules-transactions-tusale-terminal-merchant-tusale-module"
	],
	"../../../../modules/transactions/tusale/turewardclaim/merchant/turewardclaim.module": [
		"./src/app/modules/transactions/tusale/turewardclaim/merchant/turewardclaim.module.ts",
		"modules-transactions-tusale-turewardclaim-merchant-turewardclaim-module"
	],
	"../../../../panel/console/tucmall/tuambassador/tuambassador.module": [
		"./src/app/panel/console/tucmall/tuambassador/tuambassador.module.ts",
		"panel-console-tucmall-tuambassador-tuambassador-module"
	],
	"../../../../panel/console/tucmall/tuambassadors/tuambassadors.module": [
		"./src/app/panel/console/tucmall/tuambassadors/tuambassadors.module.ts",
		"panel-console-tucmall-tuambassadors-tuambassadors-module"
	],
	"../../../../panel/console/tucmall/tucorders/tucorders.module": [
		"./src/app/panel/console/tucmall/tucorders/tucorders.module.ts",
		"panel-console-tucmall-tucorders-tucorders-module"
	],
	"../../../../panel/console/tucmall/tuorders/tuorders.module": [
		"./src/app/panel/console/tucmall/tuorders/tuorders.module.ts",
		"panel-console-tucmall-tuorders-tuorders-module"
	],
	"../../../../panel/console/tucmall/tuproducts/tuproducts.module": [
		"./src/app/panel/console/tucmall/tuproducts/tuproducts.module.ts",
		"panel-console-tucmall-tuproducts-tuproducts-module"
	],
	"../../../../panel/console/tucmall/tuvariants/tuvariants.module": [
		"./src/app/panel/console/tucmall/tuvariants/tuvariants.module.ts",
		"panel-console-tucmall-tuvariants-tuvariants-module"
	],
	"../../../../panel/credentials/cashiercredentials/credentials.module": [
		"./src/app/panel/credentials/cashiercredentials/credentials.module.ts",
		"panel-credentials-cashiercredentials-credentials-module"
	],
	"../../../../panel/smscampaign/Merchant/tuallsmscampaign/tuallsmscampaign.module": [
		"./src/app/panel/smscampaign/Merchant/tuallsmscampaign/tuallsmscampaign.module.ts",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~bnpl-bnpl-module~bnploverview-bnploverview~75215596",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~bnpl-bnpl-module~bnploverview-bnploverview~de2dac75",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~modules-deals-tuadddeals-tuadddeals-module~b9019ce1",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~modules-deals-tuadddeals-tuadddeals-module~81cb151d",
		"Merchant-tuallsmscampaign-tuallsmscampaign-module"
	],
	"../../../../panel/smscampaign/allcutomers/allcutomers.module": [
		"./src/app/panel/smscampaign/allcutomers/allcutomers.module.ts",
		"panel-smscampaign-allcutomers-allcutomers-module"
	],
	"../../../../panel/smscampaign/tuallcustomersgroup/tuallcustomersgroup.module": [
		"./src/app/panel/smscampaign/tuallcustomersgroup/tuallcustomersgroup.module.ts",
		"default~account-bulkcustomerfiles-customerupload-module~account-tucustomers-tucustomers-module~merch~db57af3d",
		"panel-smscampaign-tuallcustomersgroup-tuallcustomersgroup-module"
	],
	"../../../../partner/account/topup/topup.module": [
		"./src/app/partner/account/topup/topup.module.ts",
		"partner-account-topup-topup-module"
	],
	"../../../../partner/account/tustores/merchant/tustores.module": [
		"./src/app/partner/account/tustores/merchant/tustores.module.ts",
		"default~Acquirer-BranchDivision-EditBranch-EditBranch-module~Acquirer-account-tustores-merchant-tust~edebb253",
		"partner-account-tustores-merchant-tustores-module"
	],
	"../../../../partner/account/tuterminals/merchant/tuterminals.module": [
		"./src/app/partner/account/tuterminals/merchant/tuterminals.module.ts",
		"partner-account-tuterminals-merchant-tuterminals-module"
	],
	"../../../../partner/account/tuterminals/store/tuterminals.module": [
		"./src/app/partner/account/tuterminals/store/tuterminals.module.ts",
		"partner-account-tuterminals-store-tuterminals-module"
	],
	"../../../../partner/dashboards/merchant/dashboard.module": [
		"./src/app/partner/dashboards/merchant/dashboard.module.ts",
		"partner-dashboards-merchant-dashboard-module"
	],
	"../../../../partner/dashboards/store/partner/dashboard.module": [
		"./src/app/partner/dashboards/store/partner/dashboard.module.ts",
		"partner-dashboards-store-partner-dashboard-module"
	],
	"../../../../partner/dashboards/terminal/partner/dashboard.module": [
		"./src/app/partner/dashboards/terminal/partner/dashboard.module.ts",
		"partner-dashboards-terminal-partner-dashboard-module"
	],
	"../../../../partner/transactions/tusale/merchant/acquirer/tusale.module": [
		"./src/app/partner/transactions/tusale/merchant/acquirer/tusale.module.ts",
		"partner-transactions-tusale-merchant-acquirer-tusale-module"
	],
	"../../../../partner/transactions/tusale/store/tusale.module": [
		"./src/app/partner/transactions/tusale/store/tusale.module.ts",
		"partner-transactions-tusale-store-tusale-module"
	],
	"../../../../partner/transactions/tusale/terminal/partner/tusale.module": [
		"./src/app/partner/transactions/tusale/terminal/partner/tusale.module.ts",
		"partner-transactions-tusale-terminal-partner-tusale-module"
	],
	"../../../../ptsp/dashboards/merchant/dashboard.module": [
		"./src/app/ptsp/dashboards/merchant/dashboard.module.ts",
		"ptsp-dashboards-merchant-dashboard-module"
	],
	"../../../Acquirer/BranchDivision//manager/manager.module": [
		"./src/app/Acquirer/BranchDivision/manager/manager.module.ts",
		"Acquirer-BranchDivision-manager-manager-module"
	],
	"../../../Acquirer/account/bankloyalty/bankloyalty.module": [
		"./src/app/Acquirer/account/bankloyalty/bankloyalty.module.ts",
		"Acquirer-account-bankloyalty-bankloyalty-module"
	],
	"../../../Acquirer/account/branch/branch.module": [
		"./src/app/Acquirer/account/branch/branch.module.ts",
		"Acquirer-account-branch-branch-module"
	],
	"../../../Acquirer/account/subadmins/subadmins.module": [
		"./src/app/Acquirer/account/subadmins/subadmins.module.ts",
		"Acquirer-account-subadmins-subadmins-module"
	],
	"../../../Acquirer/account/tumanagers/tusubaccounts.module": [
		"./src/app/Acquirer/account/tumanagers/tusubaccounts.module.ts",
		"Acquirer-account-tumanagers-tusubaccounts-module"
	],
	"../../../Acquirer/account/tumerchants/tumerchants.module": [
		"./src/app/Acquirer/account/tumerchants/tumerchants.module.ts",
		"Acquirer-account-tumerchants-tumerchants-module"
	],
	"../../../Acquirer/account/tustores/acquirer/tustores.module": [
		"./src/app/Acquirer/account/tustores/acquirer/tustores.module.ts",
		"Acquirer-account-tustores-acquirer-tustores-module"
	],
	"../../../Acquirer/account/tustores/branch/tustores.module": [
		"./src/app/Acquirer/account/tustores/branch/tustores.module.ts",
		"Acquirer-account-tustores-branch-tustores-module"
	],
	"../../../Acquirer/account/tuterminals/acquirer/tuterminals.module": [
		"./src/app/Acquirer/account/tuterminals/acquirer/tuterminals.module.ts",
		"Acquirer-account-tuterminals-acquirer-tuterminals-module"
	],
	"../../../Acquirer/account/tuterminals/branch/tuterminals.module": [
		"./src/app/Acquirer/account/tuterminals/branch/tuterminals.module.ts",
		"Acquirer-account-tuterminals-branch-tuterminals-module"
	],
	"../../../Acquirer/accountcreation/addbranch/addbranch.module": [
		"./src/app/Acquirer/accountcreation/addbranch/addbranch.module.ts",
		"default~Acquirer-BranchDivision-EditBranch-EditBranch-module~Acquirer-account-tustores-merchant-tust~edebb253",
		"Acquirer-accountcreation-addbranch-addbranch-module"
	],
	"../../../Acquirer/accountcreation/merchantonboarding/merchantonboarding.module": [
		"./src/app/Acquirer/accountcreation/merchantonboarding/merchantonboarding.module.ts",
		"default~Acquirer-BranchDivision-EditBranch-EditBranch-module~Acquirer-account-tustores-merchant-tust~edebb253",
		"Acquirer-accountcreation-merchantonboarding-merchantonboarding-module"
	],
	"../../../Acquirer/accountdetails/BranchDetails/branchdetails.module": [
		"./src/app/Acquirer/accountdetails/BranchDetails/branchdetails.module.ts",
		"Acquirer-accountdetails-BranchDetails-branchdetails-module"
	],
	"../../../Acquirer/accountdetails/subadmindetails/subadmindetails.module": [
		"./src/app/Acquirer/accountdetails/subadmindetails/subadmindetails.module.ts",
		"Acquirer-accountdetails-subadmindetails-subadmindetails-module"
	],
	"../../../Acquirer/accountdetails/tubankloyalty/tubankloyalty.module": [
		"./src/app/Acquirer/accountdetails/tubankloyalty/tubankloyalty.module.ts",
		"default~Acquirer-BranchDivision-EditBranch-EditBranch-module~Acquirer-account-tustores-merchant-tust~edebb253",
		"Acquirer-accountdetails-tubankloyalty-tubankloyalty-module"
	],
	"../../../Acquirer/accountdetails/tucampaign/acquirer/tucampaign.module": [
		"./src/app/Acquirer/accountdetails/tucampaign/acquirer/tucampaign.module.ts",
		"Acquirer-accountdetails-tucampaign-acquirer-tucampaign-module"
	],
	"../../../Acquirer/accountdetails/tucconfiguration/tucconfiguration.module": [
		"./src/app/Acquirer/accountdetails/tucconfiguration/tucconfiguration.module.ts",
		"Acquirer-accountdetails-tucconfiguration-tucconfiguration-module"
	],
	"../../../Acquirer/accountdetails/tumanager/acquirer/tumanager.module": [
		"./src/app/Acquirer/accountdetails/tumanager/acquirer/tumanager.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"Acquirer-accountdetails-tumanager-acquirer-tumanager-module"
	],
	"../../../Acquirer/accountdetails/tumerchant/acquirer/tumerchant.module": [
		"./src/app/Acquirer/accountdetails/tumerchant/acquirer/tumerchant.module.ts",
		"default~Acquirer-BranchDivision-EditBranch-EditBranch-module~Acquirer-account-tustores-merchant-tust~edebb253",
		"Acquirer-accountdetails-tumerchant-acquirer-tumerchant-module"
	],
	"../../../Acquirer/accountdetails/turefer/tuanalyticsreferal/tuanalyticsreferal.module": [
		"./src/app/Acquirer/accountdetails/turefer/tuanalyticsreferal/tuanalyticsreferal.module.ts",
		"Acquirer-accountdetails-turefer-tuanalyticsreferal-tuanalyticsreferal-module"
	],
	"../../../Acquirer/accountdetails/turefer/tucodeusage/tucodeusage.module": [
		"./src/app/Acquirer/accountdetails/turefer/tucodeusage/tucodeusage.module.ts",
		"Acquirer-accountdetails-turefer-tucodeusage-tucodeusage-module"
	],
	"../../../Acquirer/accountdetails/tustore/acquirer/tustore.module": [
		"./src/app/Acquirer/accountdetails/tustore/acquirer/tustore.module.ts",
		"default~Acquirer-BranchDivision-EditBranch-EditBranch-module~Acquirer-account-tustores-merchant-tust~edebb253",
		"Acquirer-accountdetails-tustore-acquirer-tustore-module"
	],
	"../../../Acquirer/accountdetails/tuterminal/acquirer/tuterminal.module": [
		"./src/app/Acquirer/accountdetails/tuterminal/acquirer/tuterminal.module.ts",
		"Acquirer-accountdetails-tuterminal-acquirer-tuterminal-module"
	],
	"../../../Acquirer/campaigns/addcampaign/addcampaign.module": [
		"./src/app/Acquirer/campaigns/addcampaign/addcampaign.module.ts",
		"Acquirer-campaigns-addcampaign-addcampaign-module"
	],
	"../../../Acquirer/campaigns/campaigns/campaigns.module": [
		"./src/app/Acquirer/campaigns/campaigns/campaigns.module.ts",
		"Acquirer-campaigns-campaigns-campaigns-module"
	],
	"../../../Acquirer/dashboards/tuactivity/acquirer/tuactivity.module": [
		"./src/app/Acquirer/dashboards/tuactivity/acquirer/tuactivity.module.ts",
		"Acquirer-dashboards-tuactivity-acquirer-tuactivity-module"
	],
	"../../../Acquirer/transactions/tusale/acquirer/tusale.module": [
		"./src/app/Acquirer/transactions/tusale/acquirer/tusale.module.ts",
		"Acquirer-transactions-tusale-acquirer-tusale-module"
	],
	"../../../Acquirer/transactions/tusale/branch/acquirer/tusale.module": [
		"./src/app/Acquirer/transactions/tusale/branch/acquirer/tusale.module.ts",
		"Acquirer-transactions-tusale-branch-acquirer-tusale-module"
	],
	"../../../account/tuterminals/manager/tuterminals.module": [
		"./src/app/Acquirer/account/tuterminals/manager/tuterminals.module.ts",
		"account-tuterminals-manager-tuterminals-module"
	],
	"../../../account/tuterminals/store/tuterminals.module": [
		"./src/app/Acquirer/account/tuterminals/store/tuterminals.module.ts",
		"account-tuterminals-store-tuterminals-module"
	],
	"../../../accounts/tuconsole/cashiers/tucashiers.module": [
		"./src/app/modules/accounts/tuconsole/cashiers/tucashiers.module.ts",
		"accounts-tuconsole-cashiers-tucashiers-module"
	],
	"../../../accounts/tuconsole/rewardpercentage/turewardpercentage.module": [
		"./src/app/modules/accounts/tuconsole/rewardpercentage/turewardpercentage.module.ts",
		"default~accounts-tuconsole-rewardpercentage-turewardpercentage-module~tumerchant-tumerchantdetails-t~5b0b1961",
		"accounts-tuconsole-rewardpercentage-turewardpercentage-module"
	],
	"../../../accounts/tuconsole/stores/tustores.module": [
		"./src/app/modules/accounts/tuconsole/stores/tustores.module.ts",
		"accounts-tuconsole-stores-tustores-module"
	],
	"../../../accounts/tuconsole/subaccounts/tusubaccounts.module": [
		"./src/app/modules/accounts/tuconsole/subaccounts/tusubaccounts.module.ts",
		"accounts-tuconsole-subaccounts-tusubaccounts-module"
	],
	"../../../accounts/tuconsole/topup/topup.module": [
		"./src/app/modules/accounts/tuconsole/topup/topup.module.ts",
		"accounts-tuconsole-topup-topup-module"
	],
	"../../../accounts/tuconsole/tuterminals/merchant/tuterminals.module": [
		"./src/app/modules/accounts/tuconsole/tuterminals/merchant/tuterminals.module.ts",
		"accounts-tuconsole-tuterminals-merchant-tuterminals-module"
	],
	"../../../accounts/tuconsole/wallate/wallate.module": [
		"./src/app/modules/accounts/tuconsole/wallate/wallate.module.ts",
		"accounts-tuconsole-wallate-wallate-module"
	],
	"../../../accounts/tuproducts/tuproducts.module": [
		"./src/app/ptsp/accounts/tuproducts/tuproducts.module.ts",
		"accounts-tuproducts-tuproducts-module"
	],
	"../../../accounts/tuterminals/merchant/tumerchantterminal.module": [
		"./src/app/ptsp/accounts/tuterminals/merchant/tumerchantterminal.module.ts",
		"accounts-tuterminals-merchant-tumerchantterminal-module"
	],
	"../../../acountsettings/tusettings/userprofile/loginhistory/loginhistory.module": [
		"./src/app/modules/acountsettings/tusettings/userprofile/loginhistory/loginhistory.module.ts",
		"acountsettings-tusettings-userprofile-loginhistory-loginhistory-module"
	],
	"../../../app/modules/acountsettings/tusettings/tuaddroles/tuaddroles.module": [
		"./src/app/modules/acountsettings/tusettings/tuaddroles/tuaddroles.module.ts",
		"app-modules-acountsettings-tusettings-tuaddroles-tuaddroles-module"
	],
	"../../../app/modules/acountsettings/tusettings/tueditroles/tueditroles.module": [
		"./src/app/modules/acountsettings/tusettings/tueditroles/tueditroles.module.ts",
		"app-modules-acountsettings-tusettings-tueditroles-tueditroles-module"
	],
	"../../../dashboards/campaign/dashboard.module": [
		"./src/app/modules/dashboards/campaign/dashboard.module.ts",
		"dashboards-campaign-dashboard-module"
	],
	"../../../dashboards/cashier/dashboard.module": [
		"./src/app/modules/dashboards/cashier/dashboard.module.ts",
		"dashboards-cashier-dashboard-module"
	],
	"../../../dashboards/rewardnredeem/rewardnredeem.module": [
		"./src/app/Customer/modules/dashboards/rewardnredeem/rewardnredeem.module.ts",
		"dashboards-rewardnredeem-rewardnredeem-module"
	],
	"../../../dashboards/store/acquirer/dashboard.module": [
		"./src/app/Acquirer/dashboards/store/acquirer/dashboard.module.ts",
		"dashboards-store-acquirer-dashboard-module"
	],
	"../../../dashboards/terminal/dashboard.module": [
		"./src/app/ptsp/dashboards/terminal/dashboard.module.ts",
		"dashboards-terminal-dashboard-module"
	],
	"../../../dashboards/walletinfo/walletinfo.module": [
		"./src/app/Customer/modules/dashboards/walletinfo/walletinfo.module.ts",
		"dashboards-walletinfo-walletinfo-module"
	],
	"../../../partner/account/bulkcustomer/customerupload.module": [
		"./src/app/partner/account/bulkcustomer/customerupload.module.ts",
		"default~account-bulkcustomerfiles-customerupload-module~account-tucustomers-tucustomers-module~merch~db57af3d",
		"partner-account-bulkcustomer-customerupload-module"
	],
	"../../../partner/account/bulkmerchant/merchantupload.module": [
		"./src/app/partner/account/bulkmerchant/merchantupload.module.ts",
		"default~account-bulkcustomerfiles-customerupload-module~account-tucustomers-tucustomers-module~merch~db57af3d",
		"partner-account-bulkmerchant-merchantupload-module"
	],
	"../../../partner/account/subadmins/subadmins.module": [
		"./src/app/partner/account/subadmins/subadmins.module.ts",
		"partner-account-subadmins-subadmins-module"
	],
	"../../../partner/account/tumerchants/tumerchants.module": [
		"./src/app/partner/account/tumerchants/tumerchants.module.ts",
		"partner-account-tumerchants-tumerchants-module"
	],
	"../../../partner/account/tustores/partner/tustores.module": [
		"./src/app/partner/account/tustores/partner/tustores.module.ts",
		"partner-account-tustores-partner-tustores-module"
	],
	"../../../partner/account/tuterminals/partner/tuterminals.module": [
		"./src/app/partner/account/tuterminals/partner/tuterminals.module.ts",
		"partner-account-tuterminals-partner-tuterminals-module"
	],
	"../../../partner/accountcreation/merchantonboarding/merchantonboarding.module": [
		"./src/app/partner/accountcreation/merchantonboarding/merchantonboarding.module.ts",
		"default~Acquirer-BranchDivision-EditBranch-EditBranch-module~Acquirer-account-tustores-merchant-tust~edebb253",
		"partner-accountcreation-merchantonboarding-merchantonboarding-module"
	],
	"../../../partner/accountdetails/tumerchant/partner/tumerchant.module": [
		"./src/app/partner/accountdetails/tumerchant/partner/tumerchant.module.ts",
		"default~Acquirer-BranchDivision-EditBranch-EditBranch-module~Acquirer-account-tustores-merchant-tust~edebb253",
		"partner-accountdetails-tumerchant-partner-tumerchant-module"
	],
	"../../../partner/accountdetails/tustore/partner/tustore.module": [
		"./src/app/partner/accountdetails/tustore/partner/tustore.module.ts",
		"default~Acquirer-BranchDivision-EditBranch-EditBranch-module~Acquirer-account-tustores-merchant-tust~edebb253",
		"partner-accountdetails-tustore-partner-tustore-module"
	],
	"../../../partner/accountdetails/tuterminal/partner/tuterminal.module": [
		"./src/app/partner/accountdetails/tuterminal/partner/tuterminal.module.ts",
		"partner-accountdetails-tuterminal-partner-tuterminal-module"
	],
	"../../../partner/dashboards/activity/tuactivity.module": [
		"./src/app/partner/dashboards/activity/tuactivity.module.ts",
		"partner-dashboards-activity-tuactivity-module"
	],
	"../../../partner/dashboards/root/dashboard.module": [
		"./src/app/partner/dashboards/root/dashboard.module.ts",
		"partner-dashboards-root-dashboard-module"
	],
	"../../../partner/dashboards/tudetailpartner/dashboard.module": [
		"./src/app/partner/dashboards/tudetailpartner/dashboard.module.ts",
		"default~Acquirer-BranchDivision-EditBranch-EditBranch-module~Acquirer-account-tustores-merchant-tust~edebb253",
		"partner-dashboards-tudetailpartner-dashboard-module"
	],
	"../../../partner/transactions/tusale/partner/tusale.module": [
		"./src/app/partner/transactions/tusale/partner/tusale.module.ts",
		"partner-transactions-tusale-partner-tusale-module"
	],
	"../../../pssp/dashboards/tudetailpssp/dashboard.module": [
		"./src/app/pssp/dashboards/tudetailpssp/dashboard.module.ts",
		"default~Acquirer-BranchDivision-EditBranch-EditBranch-module~Acquirer-account-tustores-merchant-tust~edebb253",
		"pssp-dashboards-tudetailpssp-dashboard-module"
	],
	"../../../pssp/transactions/tusale/pssp/tusale.module": [
		"./src/app/pssp/transactions/tusale/pssp/tusale.module.ts",
		"pssp-transactions-tusale-pssp-tusale-module"
	],
	"../../../pssp/transactions/tusale/redeemhistory/pssp/tusale.module": [
		"./src/app/pssp/transactions/tusale/redeemhistory/pssp/tusale.module.ts",
		"pssp-transactions-tusale-redeemhistory-pssp-tusale-module"
	],
	"../../../pssp/transactions/tusale/rewardhistory/pssp/tusale.module": [
		"./src/app/pssp/transactions/tusale/rewardhistory/pssp/tusale.module.ts",
		"pssp-transactions-tusale-rewardhistory-pssp-tusale-module"
	],
	"../../../pssp/transactions/tusale/turewardclaim/pssp/turewardclaim.module": [
		"./src/app/pssp/transactions/tusale/turewardclaim/pssp/turewardclaim.module.ts",
		"pssp-transactions-tusale-turewardclaim-pssp-turewardclaim-module"
	],
	"../../../ptsp/accountdetails/tumerchant/ptsp/tumerchant.module": [
		"./src/app/ptsp/accountdetails/tumerchant/ptsp/tumerchant.module.ts",
		"ptsp-accountdetails-tumerchant-ptsp-tumerchant-module"
	],
	"../../../ptsp/accountdetails/tustore/tustore.module": [
		"./src/app/ptsp/accountdetails/tustore/tustore.module.ts",
		"ptsp-accountdetails-tustore-tustore-module"
	],
	"../../../ptsp/accountdetails/tuterminal/ptsp/tuterminal.module": [
		"./src/app/ptsp/accountdetails/tuterminal/ptsp/tuterminal.module.ts",
		"ptsp-accountdetails-tuterminal-ptsp-tuterminal-module"
	],
	"../../../ptsp/accounts/tumerchants/ptsp/tumerchants.module": [
		"./src/app/ptsp/accounts/tumerchants/ptsp/tumerchants.module.ts",
		"ptsp-accounts-tumerchants-ptsp-tumerchants-module"
	],
	"../../../ptsp/accounts/tustores/ptsp/tustores.module": [
		"./src/app/ptsp/accounts/tustores/ptsp/tustores.module.ts",
		"ptsp-accounts-tustores-ptsp-tustores-module"
	],
	"../../../ptsp/accounts/tuterminals/ptsp/tuterminals.module": [
		"./src/app/ptsp/accounts/tuterminals/ptsp/tuterminals.module.ts",
		"ptsp-accounts-tuterminals-ptsp-tuterminals-module"
	],
	"../../../ptsp/accounts/tuterminals/store/terminals.module": [
		"./src/app/ptsp/accounts/tuterminals/store/terminals.module.ts",
		"ptsp-accounts-tuterminals-store-terminals-module"
	],
	"../../../ptsp/dashboards/root/dashboard.module": [
		"./src/app/ptsp/dashboards/root/dashboard.module.ts",
		"ptsp-dashboards-root-dashboard-module"
	],
	"../../../ptsp/dashboards/store/dashboard.module": [
		"./src/app/ptsp/dashboards/store/dashboard.module.ts",
		"ptsp-dashboards-store-dashboard-module"
	],
	"../../../ptsp/dashboards/tudetailptsp/dashboard.module": [
		"./src/app/ptsp/dashboards/tudetailptsp/dashboard.module.ts",
		"default~Acquirer-BranchDivision-EditBranch-EditBranch-module~Acquirer-account-tustores-merchant-tust~edebb253",
		"ptsp-dashboards-tudetailptsp-dashboard-module"
	],
	"../../../ptsp/dashboards/tuposactivity/tuposactivity.module": [
		"./src/app/ptsp/dashboards/tuposactivity/tuposactivity.module.ts",
		"ptsp-dashboards-tuposactivity-tuposactivity-module"
	],
	"../../../ptsp/transactions/ptsp/tusale/tupostransactions.module": [
		"./src/app/ptsp/transactions/ptsp/tusale/tupostransactions.module.ts",
		"ptsp-transactions-ptsp-tusale-tupostransactions-module"
	],
	"../../../ptsp/transactions/store/transactions.module": [
		"./src/app/ptsp/transactions/store/transactions.module.ts",
		"ptsp-transactions-store-transactions-module"
	],
	"../../../ptsp/transactions/tucommisonhistory/tucommisionhistory.module": [
		"./src/app/ptsp/transactions/tucommisonhistory/tucommisionhistory.module.ts",
		"ptsp-transactions-tucommisonhistory-tucommisionhistory-module"
	],
	"../../../transactions/merchant/tutransactions.module": [
		"./src/app/ptsp/transactions/merchant/tutransactions.module.ts",
		"transactions-merchant-tutransactions-module"
	],
	"../../../transactions/terminal/transactions.module": [
		"./src/app/ptsp/transactions/terminal/transactions.module.ts",
		"transactions-terminal-transactions-module"
	],
	"../../Acquirer/BranchDivision/EditBranch/EditBranch.module": [
		"./src/app/Acquirer/BranchDivision/EditBranch/EditBranch.module.ts",
		"default~Acquirer-BranchDivision-EditBranch-EditBranch-module~Acquirer-account-tustores-merchant-tust~edebb253",
		"Acquirer-BranchDivision-EditBranch-EditBranch-module"
	],
	"../../Acquirer/account/tuacquirers/tuacquirers.module": [
		"./src/app/Acquirer/account/tuacquirers/tuacquirers.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"Acquirer-account-tuacquirers-tuacquirers-module"
	],
	"../../Acquirer/accountcreation/tuaddacquirer/tuaddacquirer.module": [
		"./src/app/Acquirer/accountcreation/tuaddacquirer/tuaddacquirer.module.ts",
		"default~Acquirer-BranchDivision-EditBranch-EditBranch-module~Acquirer-account-tustores-merchant-tust~edebb253",
		"Acquirer-accountcreation-tuaddacquirer-tuaddacquirer-module"
	],
	"../../Acquirer/accountcreation/tuaddreferal/tuaddreferal.module": [
		"./src/app/Acquirer/accountcreation/tuaddreferal/tuaddreferal.module.ts",
		"default~Acquirer-BranchDivision-EditBranch-EditBranch-module~Acquirer-account-tustores-merchant-tust~edebb253",
		"Acquirer-accountcreation-tuaddreferal-tuaddreferal-module"
	],
	"../../Acquirer/accountdetails/tuacquirer/tuacquirer.module": [
		"./src/app/Acquirer/accountdetails/tuacquirer/tuacquirer.module.ts",
		"Acquirer-accountdetails-tuacquirer-tuacquirer-module"
	],
	"../../Acquirer/accountdetails/turefer/turefer.module": [
		"./src/app/Acquirer/accountdetails/turefer/turefer.module.ts",
		"Acquirer-accountdetails-turefer-turefer-module"
	],
	"../../Customer/modules/accountdetails/tucustomer/tucustomer.module": [
		"./src/app/Customer/modules/accountdetails/tucustomer/tucustomer.module.ts",
		"default~Customer-modules-accountdetails-tucustomer-tucustomer-module~transactions-tusale-tugiftcards~a1dcb434",
		"Customer-modules-accountdetails-tucustomer-tucustomer-module"
	],
	"../../Customer/modules/accounts/tucustomer/customers/tucustomers.module": [
		"./src/app/Customer/modules/accounts/tucustomer/customers/tucustomers.module.ts",
		"Customer-modules-accounts-tucustomer-customers-tucustomers-module"
	],
	"../../account/bulkcustomerfiles/customerupload.module": [
		"./src/app/partner/account/bulkcustomerfiles/customerupload.module.ts",
		"default~account-bulkcustomerfiles-customerupload-module~account-tucustomers-tucustomers-module~merch~db57af3d",
		"account-bulkcustomerfiles-customerupload-module"
	],
	"../../account/tucustomers/tucustomers.module": [
		"./src/app/partner/account/tucustomers/tucustomers.module.ts",
		"default~account-bulkcustomerfiles-customerupload-module~account-tucustomers-tucustomers-module~merch~db57af3d",
		"account-tucustomers-tucustomers-module"
	],
	"../../bnpl/bnpl.module": [
		"./src/app/bnpl/bnpl.module.ts",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~bnpl-bnpl-module~bnploverview-bnploverview~75215596",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~bnpl-bnpl-module~bnploverview-bnploverview~de2dac75",
		"default~bnpl-bnpl-module~panel-accounts-tuinvoices-invoicedetails-invoicedetails-module~panel-consol~db3b6e14",
		"default~bnpl-bnpl-module~merchantsettlements-merchantsettlements-module~panels-console-console-modul~d36a67a7",
		"default~bnpl-bnpl-module~bnploverview-bnploverview-module~panels-console-console-module",
		"default~bnpl-bnpl-module~bnplmerchants-bnplmerchants-module~panels-console-console-module",
		"default~bnpl-bnpl-module~invoicesandreports-invoicesandreports-module~panels-console-console-module",
		"default~bnpl-bnpl-module~panels-console-console-module"
	],
	"../../dashboards/root/dashboard.module": [
		"./src/app/Acquirer/dashboards/root/dashboard.module.ts",
		"dashboards-root-dashboard-module"
	],
	"../../dashboards/tudetailacquirer/dashboard.module": [
		"./src/app/Acquirer/dashboards/tudetailacquirer/dashboard.module.ts",
		"default~Acquirer-BranchDivision-EditBranch-EditBranch-module~Acquirer-account-tustores-merchant-tust~edebb253",
		"dashboards-tudetailacquirer-dashboard-module"
	],
	"../../dashboards/tudetailreferal/dashboard.module": [
		"./src/app/Acquirer/dashboards/tudetailreferal/dashboard.module.ts",
		"default~Acquirer-BranchDivision-EditBranch-EditBranch-module~Acquirer-account-tustores-merchant-tust~edebb253",
		"dashboards-tudetailreferal-dashboard-module"
	],
	"../../gift-card/gift-card.module": [
		"./src/app/gift-card/gift-card.module.ts",
		"gift-card-gift-card-module"
	],
	"../../modules/accountdetails/tuconsole/tucambassador/tucambassador.module": [
		"./src/app/modules/accountdetails/tuconsole/tucambassador/tucambassador.module.ts",
		"modules-accountdetails-tuconsole-tucambassador-tucambassador-module"
	],
	"../../modules/accountdetails/tuconsole/tucampaign/tucampaign.module": [
		"./src/app/modules/accountdetails/tuconsole/tucampaign/tucampaign.module.ts",
		"modules-accountdetails-tuconsole-tucampaign-tucampaign-module"
	],
	"../../modules/accountdetails/tuconsole/tucashier/tucashier.module": [
		"./src/app/modules/accountdetails/tuconsole/tucashier/tucashier.module.ts",
		"modules-accountdetails-tuconsole-tucashier-tucashier-module"
	],
	"../../modules/accountdetails/tuconsole/tumerchant/tumerchant.module": [
		"./src/app/modules/accountdetails/tuconsole/tumerchant/tumerchant.module.ts",
		"default~Acquirer-BranchDivision-EditBranch-EditBranch-module~Acquirer-account-tustores-merchant-tust~edebb253",
		"modules-accountdetails-tuconsole-tumerchant-tumerchant-module"
	],
	"../../modules/accountdetails/tuconsole/tuproduct/tuproduct.module": [
		"./src/app/modules/accountdetails/tuconsole/tuproduct/tuproduct.module.ts",
		"modules-accountdetails-tuconsole-tuproduct-tuproduct-module"
	],
	"../../modules/accountdetails/tuconsole/tusettings/tusettings.module": [
		"./src/app/modules/accountdetails/tuconsole/tusettings/tusettings.module.ts",
		"modules-accountdetails-tuconsole-tusettings-tusettings-module"
	],
	"../../modules/accountdetails/tuconsole/tustore/tustore.module": [
		"./src/app/modules/accountdetails/tuconsole/tustore/tustore.module.ts",
		"default~Acquirer-BranchDivision-EditBranch-EditBranch-module~Acquirer-account-tustores-merchant-tust~edebb253",
		"modules-accountdetails-tuconsole-tustore-tustore-module"
	],
	"../../modules/accountdetails/tuconsole/tusubaccount/tusubaccount.module": [
		"./src/app/modules/accountdetails/tuconsole/tusubaccount/tusubaccount.module.ts",
		"modules-accountdetails-tuconsole-tusubaccount-tusubaccount-module"
	],
	"../../modules/accountdetails/tuconsole/tuterminal/tuterminal.module": [
		"./src/app/modules/accountdetails/tuconsole/tuterminal/tuterminal.module.ts",
		"modules-accountdetails-tuconsole-tuterminal-tuterminal-module"
	],
	"../../modules/accounts/tuconsole/bankreconciliation/bank.module": [
		"./src/app/modules/accounts/tuconsole/bankreconciliation/bank.module.ts",
		"modules-accounts-tuconsole-bankreconciliation-bank-module"
	],
	"../../modules/accounts/tuconsole/bulkterminallist/tuterminals.module": [
		"./src/app/modules/accounts/tuconsole/bulkterminallist/tuterminals.module.ts",
		"default~account-bulkcustomerfiles-customerupload-module~account-tucustomers-tucustomers-module~merch~db57af3d",
		"modules-accounts-tuconsole-bulkterminallist-tuterminals-module"
	],
	"../../modules/accounts/tuconsole/bulkterminalupload/tuterminals.module": [
		"./src/app/modules/accounts/tuconsole/bulkterminalupload/tuterminals.module.ts",
		"default~account-bulkcustomerfiles-customerupload-module~account-tucustomers-tucustomers-module~merch~db57af3d",
		"modules-accounts-tuconsole-bulkterminalupload-tuterminals-module"
	],
	"../../modules/accounts/tuconsole/cashiers/tucashiers.module": [
		"./src/app/modules/accounts/tuconsole/cashiers/tucashiers.module.ts",
		"accounts-tuconsole-cashiers-tucashiers-module"
	],
	"../../modules/accounts/tuconsole/merchants/tumerchants.module": [
		"./src/app/modules/accounts/tuconsole/merchants/tumerchants.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"modules-accounts-tuconsole-merchants-tumerchants-module"
	],
	"../../modules/acountsettings/tusettings/adminuser/adminuser.module": [
		"./src/app/modules/acountsettings/tusettings/adminuser/adminuser.module.ts",
		"modules-acountsettings-tusettings-adminuser-adminuser-module"
	],
	"../../modules/acountsettings/tusettings/tusettings.module": [
		"./src/app/modules/acountsettings/tusettings/tusettings.module.ts",
		"modules-acountsettings-tusettings-tusettings-module"
	],
	"../../modules/acountsettings/tusettings/userprofile/tuuserprofile.module": [
		"./src/app/modules/acountsettings/tusettings/userprofile/tuuserprofile.module.ts",
		"modules-acountsettings-tusettings-userprofile-tuuserprofile-module"
	],
	"../../modules/dashboards/loyality/campaigns/tucampaigns.module": [
		"./src/app/modules/dashboards/loyality/campaigns/tucampaigns.module.ts",
		"modules-dashboards-loyality-campaigns-tucampaigns-module"
	],
	"../../modules/dashboards/loyality/overview/dashboard.module": [
		"./src/app/modules/dashboards/loyality/overview/dashboard.module.ts",
		"modules-dashboards-loyality-overview-dashboard-module"
	],
	"../../modules/dashboards/loyality/visits/dashboard.module": [
		"./src/app/modules/dashboards/loyality/visits/dashboard.module.ts",
		"modules-dashboards-loyality-visits-dashboard-module"
	],
	"../../modules/dashboards/mybuisness/tusalestrends/tusalestrends.module": [
		"./src/app/modules/dashboards/mybuisness/tusalestrends/tusalestrends.module.ts",
		"modules-dashboards-mybuisness-tusalestrends-tusalestrends-module"
	],
	"../../modules/dashboards/mybuisness/tusalesummary/tusalesummary.module": [
		"./src/app/modules/dashboards/mybuisness/tusalesummary/tusalesummary.module.ts",
		"modules-dashboards-mybuisness-tusalesummary-tusalesummary-module"
	],
	"../../modules/transactions/tusale/Pendingtransaction/console/pendingtransaction/pendingtransaction.module": [
		"./src/app/modules/transactions/tusale/Pendingtransaction/console/pendingtransaction/pendingtransaction.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"modules-transactions-tusale-Pendingtransaction-console-pendingtransaction-pendingtransaction-module"
	],
	"../../modules/transactions/tusale/dailyreport/tusale.module": [
		"./src/app/modules/transactions/tusale/dailyreport/tusale.module.ts",
		"modules-transactions-tusale-dailyreport-tusale-module"
	],
	"../../modules/transactions/tusale/merchant/tusale.module": [
		"./src/app/modules/transactions/tusale/merchant/tusale.module.ts",
		"modules-transactions-tusale-merchant-tusale-module"
	],
	"../../modules/transactions/tusale/pendingrewardhistory/tusale.module": [
		"./src/app/modules/transactions/tusale/pendingrewardhistory/tusale.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"modules-transactions-tusale-pendingrewardhistory-tusale-module"
	],
	"../../modules/transactions/tusale/redeemhistory/dailyreport/tusale.module": [
		"./src/app/modules/transactions/tusale/redeemhistory/dailyreport/tusale.module.ts",
		"modules-transactions-tusale-redeemhistory-dailyreport-tusale-module"
	],
	"../../modules/transactions/tusale/redeemhistory/tusale.module": [
		"./src/app/modules/transactions/tusale/redeemhistory/tusale.module.ts",
		"modules-transactions-tusale-redeemhistory-tusale-module"
	],
	"../../modules/transactions/tusale/rewardhistory/dailyreport/tusale.module": [
		"./src/app/modules/transactions/tusale/rewardhistory/dailyreport/tusale.module.ts",
		"modules-transactions-tusale-rewardhistory-dailyreport-tusale-module"
	],
	"../../modules/transactions/tusale/rewardhistory/tusale.module": [
		"./src/app/modules/transactions/tusale/rewardhistory/tusale.module.ts",
		"modules-transactions-tusale-rewardhistory-tusale-module"
	],
	"../../modules/transactions/tusale/turewardclaim/dailyreport/turewardclaim.module": [
		"./src/app/modules/transactions/tusale/turewardclaim/dailyreport/turewardclaim.module.ts",
		"modules-transactions-tusale-turewardclaim-dailyreport-turewardclaim-module"
	],
	"../../modules/transactions/tusale/turewardclaim/turewardclaim.module": [
		"./src/app/modules/transactions/tusale/turewardclaim/turewardclaim.module.ts",
		"modules-transactions-tusale-turewardclaim-turewardclaim-module"
	],
	"../../modules/transactions/tusale/tusale.module": [
		"./src/app/modules/transactions/tusale/tusale.module.ts",
		"modules-transactions-tusale-tusale-module"
	],
	"../../pages/merchantOnboarding/accountDetail/accountDetail.module": [
		"./src/app/pages/merchantOnboarding/accountDetail/accountDetail.module.ts",
		"default~Acquirer-BranchDivision-EditBranch-EditBranch-module~Acquirer-account-tustores-merchant-tust~edebb253",
		"pages-merchantOnboarding-accountDetail-accountDetail-module"
	],
	"../../pages/merchantOnboarding/businessDetail/businessDetail.module": [
		"./src/app/pages/merchantOnboarding/businessDetail/businessDetail.module.ts",
		"default~Acquirer-BranchDivision-EditBranch-EditBranch-module~Acquirer-account-tustores-merchant-tust~edebb253",
		"pages-merchantOnboarding-businessDetail-businessDetail-module"
	],
	"../../pages/useronboarding/merchantonboarding/merchantonboarding.module": [
		"./src/app/pages/useronboarding/merchantonboarding/merchantonboarding.module.ts",
		"default~Acquirer-BranchDivision-EditBranch-EditBranch-module~Acquirer-account-tustores-merchant-tust~edebb253",
		"pages-useronboarding-merchantonboarding-merchantonboarding-module"
	],
	"../../panel/accounts/cashiers/tucashiers.module": [
		"./src/app/panel/accounts/cashiers/tucashiers.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"panel-accounts-cashiers-tucashiers-module"
	],
	"../../panel/accounts/samlecolapsetable/samlecolapsetable.module": [
		"./src/app/panel/accounts/samlecolapsetable/samlecolapsetable.module.ts",
		"panel-accounts-samlecolapsetable-samlecolapsetable-module"
	],
	"../../panel/accounts/stores/tustores.module": [
		"./src/app/panel/accounts/stores/tustores.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"default~Acquirer-BranchDivision-EditBranch-EditBranch-module~Acquirer-account-tustores-merchant-tust~edebb253",
		"panel-accounts-stores-tustores-module"
	],
	"../../panel/accounts/tucashouts/tucashoutsale/tupayments.module": [
		"./src/app/panel/accounts/tucashouts/tucashoutsale/tupayments.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"panel-accounts-tucashouts-tucashoutsale-tupayments-module"
	],
	"../../panel/accounts/tucashouts/tumerchantcashouts/tumerchantcashouts.module": [
		"./src/app/panel/accounts/tucashouts/tumerchantcashouts/tumerchantcashouts.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"panel-accounts-tucashouts-tumerchantcashouts-tumerchantcashouts-module"
	],
	"../../panel/accounts/tucsupercash/tucsupercash/tucsupercash.module": [
		"./src/app/panel/accounts/tucsupercash/tucsupercash/tucsupercash.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"panel-accounts-tucsupercash-tucsupercash-tucsupercash-module"
	],
	"../../panel/accounts/tudownloads/tudownloads.module": [
		"./src/app/panel/accounts/tudownloads/tudownloads.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"panel-accounts-tudownloads-tudownloads-module"
	],
	"../../panel/accounts/tuinvoices/invoicedetails/invoicedetails.module": [
		"./src/app/panel/accounts/tuinvoices/invoicedetails/invoicedetails.module.ts",
		"default~bnpl-bnpl-module~panel-accounts-tuinvoices-invoicedetails-invoicedetails-module~panel-consol~db3b6e14",
		"panel-accounts-tuinvoices-invoicedetails-invoicedetails-module"
	],
	"../../panel/accounts/tuinvoices/tuinvoices.module": [
		"./src/app/panel/accounts/tuinvoices/tuinvoices.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"panel-accounts-tuinvoices-tuinvoices-module"
	],
	"../../panel/accounts/tumerchantplans/tumerchantplan/tumerchantplan.module": [
		"./src/app/panel/accounts/tumerchantplans/tumerchantplan/tumerchantplan.module.ts",
		"panel-accounts-tumerchantplans-tumerchantplan-tumerchantplan-module"
	],
	"../../panel/accounts/tumerchantplans/tumerchantplans.module": [
		"./src/app/panel/accounts/tumerchantplans/tumerchantplans.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"panel-accounts-tumerchantplans-tumerchantplans-module"
	],
	"../../panel/accounts/tupayments/tupayments.module": [
		"./src/app/panel/accounts/tupayments/tupayments.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"panel-accounts-tupayments-tupayments-module"
	],
	"../../panel/accounts/tupayments/tuvasanalytics/tuvasanalytics.module": [
		"./src/app/panel/accounts/tupayments/tuvasanalytics/tuvasanalytics.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"default~panel-accounts-tupayments-tuvasanalytics-tuvasanalytics-module~panel-console-analytics-tuove~b0048449",
		"panel-accounts-tupayments-tuvasanalytics-tuvasanalytics-module"
	],
	"../../panel/accounts/tupayments/tuvascategories/tuvascategories.module": [
		"./src/app/panel/accounts/tupayments/tuvascategories/tuvascategories.module.ts",
		"panel-accounts-tupayments-tuvascategories-tuvascategories-module"
	],
	"../../panel/accounts/tupayments/tuvasproduct/tuvasproduct.module": [
		"./src/app/panel/accounts/tupayments/tuvasproduct/tuvasproduct.module.ts",
		"panel-accounts-tupayments-tuvasproduct-tuvasproduct-module"
	],
	"../../panel/accounts/turef/turef/turef.module": [
		"./src/app/panel/accounts/turef/turef/turef.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"panel-accounts-turef-turef-turef-module"
	],
	"../../panel/accounts/turefbonus/turefbonus/turefbonus.module": [
		"./src/app/panel/accounts/turefbonus/turefbonus/turefbonus.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"panel-accounts-turefbonus-turefbonus-turefbonus-module"
	],
	"../../panel/accounts/turefunds/turefunds/turefunds.module": [
		"./src/app/panel/accounts/turefunds/turefunds/turefunds.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"panel-accounts-turefunds-turefunds-turefunds-module"
	],
	"../../panel/accounts/tuterminals/tuterminals.module": [
		"./src/app/panel/accounts/tuterminals/tuterminals.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"panel-accounts-tuterminals-tuterminals-module"
	],
	"../../panel/accounts/tuwallethistory/tucustomerwallethistory/tucustomerwallethistory.module": [
		"./src/app/panel/accounts/tuwallethistory/tucustomerwallethistory/tucustomerwallethistory.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"panel-accounts-tuwallethistory-tucustomerwallethistory-tucustomerwallethistory-module"
	],
	"../../panel/accounts/tuwallethistory/tumerchantwallethistory/tumerchantwallethistory.module": [
		"./src/app/panel/accounts/tuwallethistory/tumerchantwallethistory/tumerchantwallethistory.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"panel-accounts-tuwallethistory-tumerchantwallethistory-tumerchantwallethistory-module"
	],
	"../../panel/accounts/tuwallets/tucustomerwallets/tucustomerwallets.module": [
		"./src/app/panel/accounts/tuwallets/tucustomerwallets/tucustomerwallets.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"panel-accounts-tuwallets-tucustomerwallets-tucustomerwallets-module"
	],
	"../../panel/accounts/tuwallets/tumerchantwallets/tumerchantwallets.module": [
		"./src/app/panel/accounts/tuwallets/tumerchantwallets/tumerchantwallets.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"panel-accounts-tuwallets-tumerchantwallets-tumerchantwallets-module"
	],
	"../../panel/administration/hcapps/hcapps.module": [
		"./src/app/panel/administration/hcapps/hcapps.module.ts",
		"panel-administration-hcapps-hcapps-module"
	],
	"../../panel/administration/hcapps/tuapplist/tuapplist.module": [
		"./src/app/panel/administration/hcapps/tuapplist/tuapplist.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"panel-administration-hcapps-tuapplist-tuapplist-module"
	],
	"../../panel/administration/hcapps/tunewconfig/tunewconfig.module": [
		"./src/app/panel/administration/hcapps/tunewconfig/tunewconfig.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"panel-administration-hcapps-tunewconfig-tunewconfig-module"
	],
	"../../panel/administration/tuadminfeatures/tuadminfeatures.module": [
		"./src/app/panel/administration/tuadminfeatures/tuadminfeatures.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"panel-administration-tuadminfeatures-tuadminfeatures-module"
	],
	"../../panel/administration/tuadminlogomanagement/tulogomanagement.module": [
		"./src/app/panel/administration/tuadminlogomanagement/tulogomanagement.module.ts",
		"panel-administration-tuadminlogomanagement-tulogomanagement-module"
	],
	"../../panel/administration/tuappslider/tuappslider.module": [
		"./src/app/panel/administration/tuappslider/tuappslider.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"panel-administration-tuappslider-tuappslider-module"
	],
	"../../panel/administration/tucity/tucity.module": [
		"./src/app/panel/administration/tucity/tucity.module.ts",
		"panel-administration-tucity-tucity-module"
	],
	"../../panel/administration/tuconfiguration/tuconfiguration.module": [
		"./src/app/panel/administration/tuconfiguration/tuconfiguration.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"panel-administration-tuconfiguration-tuconfiguration-module"
	],
	"../../panel/administration/tudealcategories/tudealcategories.module": [
		"./src/app/panel/administration/tudealcategories/tudealcategories.module.ts",
		"panel-administration-tudealcategories-tudealcategories-module"
	],
	"../../panel/administration/tudealcategories/tudealsubcategories/tudealsubcategories.module": [
		"./src/app/panel/administration/tudealcategories/tudealsubcategories/tudealsubcategories.module.ts",
		"panel-administration-tudealcategories-tudealsubcategories-tudealsubcategories-module"
	],
	"../../panel/administration/tudealrequest/tudealrequest.module": [
		"./src/app/panel/administration/tudealrequest/tudealrequest.module.ts",
		"panel-administration-tudealrequest-tudealrequest-module"
	],
	"../../panel/administration/tudetailscity/tudetailscity.module": [
		"./src/app/panel/administration/tudetailscity/tudetailscity.module.ts",
		"panel-administration-tudetailscity-tudetailscity-module"
	],
	"../../panel/administration/tufaqcategories/tufaqcategories.module": [
		"./src/app/panel/administration/tufaqcategories/tufaqcategories.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"panel-administration-tufaqcategories-tufaqcategories-module"
	],
	"../../panel/administration/tufaqs/tufaqs.module": [
		"./src/app/panel/administration/tufaqs/tufaqs.module.ts",
		"panel-administration-tufaqs-tufaqs-module"
	],
	"../../panel/administration/tugeneralsettings/tuhome.module": [
		"./src/app/panel/administration/tugeneralsettings/tuhome.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"panel-administration-tugeneralsettings-tuhome-module"
	],
	"../../panel/administration/tugetcity/tugetcity.module": [
		"./src/app/panel/administration/tugetcity/tugetcity.module.ts",
		"panel-administration-tugetcity-tugetcity-module"
	],
	"../../panel/administration/tugetcityarea/tugetcityarea.module": [
		"./src/app/panel/administration/tugetcityarea/tugetcityarea.module.ts",
		"panel-administration-tugetcityarea-tugetcityarea-module"
	],
	"../../panel/administration/tuhome/tuhome.module": [
		"./src/app/panel/administration/tuhome/tuhome.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"panel-administration-tuhome-tuhome-module"
	],
	"../../panel/administration/tuimagegallery/tuimagesgallery/tuimagesgallery.module": [
		"./src/app/panel/administration/tuimagegallery/tuimagesgallery/tuimagesgallery.module.ts",
		"panel-administration-tuimagegallery-tuimagesgallery-tuimagesgallery-module"
	],
	"../../panel/administration/tulogfeature/tulogfeature.module": [
		"./src/app/panel/administration/tulogfeature/tulogfeature.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"panel-administration-tulogfeature-tulogfeature-module"
	],
	"../../panel/administration/tumerchantcategories/merchantsubcategories/merchantsubcategories.module": [
		"./src/app/panel/administration/tumerchantcategories/merchantsubcategories/merchantsubcategories.module.ts",
		"panel-administration-tumerchantcategories-merchantsubcategories-merchantsubcategories-module"
	],
	"../../panel/administration/tumerchantcategories/tumerchantcategories.module": [
		"./src/app/panel/administration/tumerchantcategories/tumerchantcategories.module.ts",
		"panel-administration-tumerchantcategories-tumerchantcategories-module"
	],
	"../../panel/administration/tupushnotification/tupushnotification.module": [
		"./src/app/panel/administration/tupushnotification/tupushnotification.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"panel-administration-tupushnotification-tupushnotification-module"
	],
	"../../panel/administration/turequesthistory/turequesthistory.module": [
		"./src/app/panel/administration/turequesthistory/turequesthistory.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"panel-administration-turequesthistory-turequesthistory-module"
	],
	"../../panel/administration/turesponsemessages/turesponsemessages.module": [
		"./src/app/panel/administration/turesponsemessages/turesponsemessages.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"panel-administration-turesponsemessages-turesponsemessages-module"
	],
	"../../panel/administration/turootcategory/turootcategory.module": [
		"./src/app/panel/administration/turootcategory/turootcategory.module.ts",
		"panel-administration-turootcategory-turootcategory-module"
	],
	"../../panel/administration/tusmsnotifications/tusmsnotifications.module": [
		"./src/app/panel/administration/tusmsnotifications/tusmsnotifications.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"panel-administration-tusmsnotifications-tusmsnotifications-module"
	],
	"../../panel/administration/tusubcategories/tusubcategories.module": [
		"./src/app/panel/administration/tusubcategories/tusubcategories.module.ts"
	],
	"../../panel/administration/tusystemlog/tusystemlog.module": [
		"./src/app/panel/administration/tusystemlog/tusystemlog.module.ts",
		"panel-administration-tusystemlog-tusystemlog-module"
	],
	"../../panel/administration/tuusersession/tuusersession.module": [
		"./src/app/panel/administration/tuusersession/tuusersession.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"panel-administration-tuusersession-tuusersession-module"
	],
	"../../panel/administration/tuverficationrequest/tuverficationrequest.module": [
		"./src/app/panel/administration/tuverficationrequest/tuverficationrequest.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"panel-administration-tuverficationrequest-tuverficationrequest-module"
	],
	"../../panel/console/analytics/tucustomeranalysis/tucustomeranalysis.module": [
		"./src/app/panel/console/analytics/tucustomeranalysis/tucustomeranalysis.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"default~bnpl-bnpl-module~panel-accounts-tuinvoices-invoicedetails-invoicedetails-module~panel-consol~db3b6e14",
		"panel-console-analytics-tucustomeranalysis-tucustomeranalysis-module"
	],
	"../../panel/console/analytics/tugrowthrevenue/tugrowthrevenue.module": [
		"./src/app/panel/console/analytics/tugrowthrevenue/tugrowthrevenue.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"default~bnpl-bnpl-module~panel-accounts-tuinvoices-invoicedetails-invoicedetails-module~panel-consol~db3b6e14",
		"panel-console-analytics-tugrowthrevenue-tugrowthrevenue-module"
	],
	"../../panel/console/analytics/tumerchantanalysis/tumerchantanalysis.module": [
		"./src/app/panel/console/analytics/tumerchantanalysis/tumerchantanalysis.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"default~bnpl-bnpl-module~panel-accounts-tuinvoices-invoicedetails-invoicedetails-module~panel-consol~db3b6e14",
		"panel-console-analytics-tumerchantanalysis-tumerchantanalysis-module"
	],
	"../../panel/console/analytics/tuoverview/tuoverview.module": [
		"./src/app/panel/console/analytics/tuoverview/tuoverview.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"default~bnpl-bnpl-module~panel-accounts-tuinvoices-invoicedetails-invoicedetails-module~panel-consol~db3b6e14",
		"default~panel-accounts-tupayments-tuvasanalytics-tuvasanalytics-module~panel-console-analytics-tuove~b0048449",
		"panel-console-analytics-tuoverview-tuoverview-module"
	],
	"../../panel/console/analytics/tutodayoverviews/tutodayoverviews.module": [
		"./src/app/panel/console/analytics/tutodayoverviews/tutodayoverviews.module.ts",
		"default~panel-accounts-tupayments-tuvasanalytics-tuvasanalytics-module~panel-console-analytics-tuove~b0048449",
		"panel-console-analytics-tutodayoverviews-tutodayoverviews-module"
	],
	"../../panel/console/dashboards/root/dashboard.module": [
		"./src/app/panel/console/dashboards/root/dashboard.module.ts",
		"default~panel-accounts-tupayments-tuvasanalytics-tuvasanalytics-module~panel-console-analytics-tuove~b0048449",
		"panel-console-dashboards-root-dashboard-module"
	],
	"../../panel/console/deals/tuadddeal/tuadddeal.module": [
		"./src/app/panel/console/deals/tuadddeal/tuadddeal.module.ts",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~bnpl-bnpl-module~bnploverview-bnploverview~75215596",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~bnpl-bnpl-module~bnploverview-bnploverview~de2dac75",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~modules-deals-tuadddeals-tuadddeals-module~b9019ce1",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~modules-deals-tuadddeals-tuadddeals-module~81cb151d",
		"default~modules-deals-tuadddeals-tuadddeals-module~panel-console-deals-tuadddeal-tuadddeal-module~pa~8063d5f9",
		"panel-console-deals-tuadddeal-tuadddeal-module"
	],
	"../../panel/console/deals/tuadddeals/tuadddeals.module": [
		"./src/app/panel/console/deals/tuadddeals/tuadddeals.module.ts",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~bnpl-bnpl-module~bnploverview-bnploverview~75215596",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~bnpl-bnpl-module~bnploverview-bnploverview~de2dac75",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~modules-deals-tuadddeals-tuadddeals-module~b9019ce1",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~modules-deals-tuadddeals-tuadddeals-module~81cb151d",
		"panel-console-deals-tuadddeals-tuadddeals-module"
	],
	"../../panel/console/deals/tuapppromotion/tuapppromotion.module": [
		"./src/app/panel/console/deals/tuapppromotion/tuapppromotion.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"panel-console-deals-tuapppromotion-tuapppromotion-module"
	],
	"../../panel/console/deals/tucancelledorders/tucancelledorder.module": [
		"./src/app/panel/console/deals/tucancelledorders/tucancelledorder.module.ts",
		"panel-console-deals-tucancelledorders-tucancelledorder-module"
	],
	"../../panel/console/deals/tudeal/tudeal.module": [
		"./src/app/panel/console/deals/tudeal/tudeal.module.ts",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~bnpl-bnpl-module~bnploverview-bnploverview~75215596",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~bnpl-bnpl-module~bnploverview-bnploverview~de2dac75",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~modules-deals-tuadddeals-tuadddeals-module~b9019ce1",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~modules-deals-tuadddeals-tuadddeals-module~81cb151d",
		"default~modules-deals-tudeal-tudeal-module~panel-console-deals-tudeal-tudeal-module",
		"panel-console-deals-tudeal-tudeal-module"
	],
	"../../panel/console/deals/tudealpromotion/tudealpromotion.module": [
		"./src/app/panel/console/deals/tudealpromotion/tudealpromotion.module.ts",
		"panel-console-deals-tudealpromotion-tudealpromotion-module"
	],
	"../../panel/console/deals/tudeals/tudeals.module": [
		"./src/app/panel/console/deals/tudeals/tudeals.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~bnpl-bnpl-module~bnploverview-bnploverview~75215596",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~bnpl-bnpl-module~bnploverview-bnploverview~de2dac75",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~modules-deals-tuadddeals-tuadddeals-module~b9019ce1",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~modules-deals-tuadddeals-tuadddeals-module~81cb151d",
		"panel-console-deals-tudeals-tudeals-module"
	],
	"../../panel/console/deals/tudealscustomer/tudealscustomer.module": [
		"./src/app/panel/console/deals/tudealscustomer/tudealscustomer.module.ts",
		"panel-console-deals-tudealscustomer-tudealscustomer-module"
	],
	"../../panel/console/deals/tudealsmerchant/tudealsmerchant.module": [
		"./src/app/panel/console/deals/tudealsmerchant/tudealsmerchant.module.ts",
		"panel-console-deals-tudealsmerchant-tudealsmerchant-module"
	],
	"../../panel/console/deals/tudealsold/tudealsold.module": [
		"./src/app/panel/console/deals/tudealsold/tudealsold.module.ts",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~bnpl-bnpl-module~bnploverview-bnploverview~75215596",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~bnpl-bnpl-module~bnploverview-bnploverview~de2dac75",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~modules-deals-tuadddeals-tuadddeals-module~b9019ce1",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~modules-deals-tuadddeals-tuadddeals-module~81cb151d",
		"panel-console-deals-tudealsold-tudealsold-module"
	],
	"../../panel/console/deals/tudealspurchaseoverview/tuoverview.module": [
		"./src/app/panel/console/deals/tudealspurchaseoverview/tuoverview.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"panel-console-deals-tudealspurchaseoverview-tuoverview-module"
	],
	"../../panel/console/deals/tuduplicatedeal/tuduplicatedeal.module": [
		"./src/app/panel/console/deals/tuduplicatedeal/tuduplicatedeal.module.ts",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~bnpl-bnpl-module~bnploverview-bnploverview~75215596",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~bnpl-bnpl-module~bnploverview-bnploverview~de2dac75",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~modules-deals-tuadddeals-tuadddeals-module~b9019ce1",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~modules-deals-tuadddeals-tuadddeals-module~81cb151d",
		"panel-console-deals-tuduplicatedeal-tuduplicatedeal-module"
	],
	"../../panel/console/deals/tueditdeal/tueditdeal.module": [
		"./src/app/panel/console/deals/tueditdeal/tueditdeal.module.ts",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~bnpl-bnpl-module~bnploverview-bnploverview~75215596",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~bnpl-bnpl-module~bnploverview-bnploverview~de2dac75",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~modules-deals-tuadddeals-tuadddeals-module~b9019ce1",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~modules-deals-tuadddeals-tuadddeals-module~81cb151d",
		"default~modules-deals-tuadddeals-tuadddeals-module~panel-console-deals-tuadddeal-tuadddeal-module~pa~8063d5f9",
		"panel-console-deals-tueditdeal-tueditdeal-module"
	],
	"../../panel/console/deals/tueditdeals/tueditdeals.module": [
		"./src/app/panel/console/deals/tueditdeals/tueditdeals.module.ts",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~bnpl-bnpl-module~bnploverview-bnploverview~75215596",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~bnpl-bnpl-module~bnploverview-bnploverview~de2dac75",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~modules-deals-tuadddeals-tuadddeals-module~b9019ce1",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~modules-deals-tuadddeals-tuadddeals-module~81cb151d",
		"panel-console-deals-tueditdeals-tueditdeals-module"
	],
	"../../panel/console/deals/tueditduplicatedeals/tueditduplicatedeals.module": [
		"./src/app/panel/console/deals/tueditduplicatedeals/tueditduplicatedeals.module.ts",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~bnpl-bnpl-module~bnploverview-bnploverview~75215596",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~bnpl-bnpl-module~bnploverview-bnploverview~de2dac75",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~modules-deals-tuadddeals-tuadddeals-module~b9019ce1",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~modules-deals-tuadddeals-tuadddeals-module~81cb151d",
		"panel-console-deals-tueditduplicatedeals-tueditduplicatedeals-module"
	],
	"../../panel/console/deals/tuexternalurl/tuexternalurl.module": [
		"./src/app/panel/console/deals/tuexternalurl/tuexternalurl.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"panel-console-deals-tuexternalurl-tuexternalurl-module"
	],
	"../../panel/console/deals/tuflashdeals/tuflashdeals.module": [
		"./src/app/panel/console/deals/tuflashdeals/tuflashdeals.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"panel-console-deals-tuflashdeals-tuflashdeals-module"
	],
	"../../panel/console/deals/tupickups/rootpickup.module": [
		"./src/app/panel/console/deals/tupickups/rootpickup.module.ts",
		"panel-console-deals-tupickups-rootpickup-module"
	],
	"../../panel/console/deals/turedeemedorder/turedeemedorder.module": [
		"./src/app/panel/console/deals/turedeemedorder/turedeemedorder.module.ts",
		"panel-console-deals-turedeemedorder-turedeemedorder-module"
	],
	"../../panel/console/deals/turedeemhistory/turedeemhistory.module": [
		"./src/app/panel/console/deals/turedeemhistory/turedeemhistory.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"panel-console-deals-turedeemhistory-turedeemhistory-module"
	],
	"../../panel/console/deals/tusoldhistory/tusoldhistory.module": [
		"./src/app/panel/console/deals/tusoldhistory/tusoldhistory.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"panel-console-deals-tusoldhistory-tusoldhistory-module"
	],
	"../../panel/console/tucmall/deliveryoverview/deliveryoverview.module": [
		"./src/app/panel/console/tucmall/deliveryoverview/deliveryoverview.module.ts",
		"panel-console-tucmall-deliveryoverview-deliveryoverview-module"
	],
	"../../panel/console/tucmall/orderhistory/orderhistory.module": [
		"./src/app/panel/console/tucmall/orderhistory/orderhistory.module.ts",
		"panel-console-tucmall-orderhistory-orderhistory-module"
	],
	"../../panel/console/tucmall/tuaddambassador/tuaddambassador.module": [
		"./src/app/panel/console/tucmall/tuaddambassador/tuaddambassador.module.ts",
		"panel-console-tucmall-tuaddambassador-tuaddambassador-module"
	],
	"../../panel/console/tucmall/tuaddproduct/tuaddproduct.module": [
		"./src/app/panel/console/tucmall/tuaddproduct/tuaddproduct.module.ts",
		"panel-console-tucmall-tuaddproduct-tuaddproduct-module"
	],
	"../../panel/console/tucmall/tuambassadors/tuambassadors.module": [
		"./src/app/panel/console/tucmall/tuambassadors/tuambassadors.module.ts",
		"panel-console-tucmall-tuambassadors-tuambassadors-module"
	],
	"../../panel/console/tucmall/tucorders/tucorders.module": [
		"./src/app/panel/console/tucmall/tucorders/tucorders.module.ts",
		"panel-console-tucmall-tucorders-tucorders-module"
	],
	"../../panel/console/tucmall/tueditproduct/tueditproduct.module": [
		"./src/app/panel/console/tucmall/tueditproduct/tueditproduct.module.ts",
		"panel-console-tucmall-tueditproduct-tueditproduct-module"
	],
	"../../panel/console/tucmall/tuinvoice/tuinvoice.module": [
		"./src/app/panel/console/tucmall/tuinvoice/tuinvoice.module.ts",
		"panel-console-tucmall-tuinvoice-tuinvoice-module"
	],
	"../../panel/console/tucmall/tuongoingorders/tuorders.module": [
		"./src/app/panel/console/tucmall/tuongoingorders/tuorders.module.ts",
		"panel-console-tucmall-tuongoingorders-tuorders-module"
	],
	"../../panel/console/tucmall/tuorder/tuorder.module": [
		"./src/app/panel/console/tucmall/tuorder/tuorder.module.ts",
		"default~bnpl-bnpl-module~panel-accounts-tuinvoices-invoicedetails-invoicedetails-module~panel-consol~db3b6e14",
		"panel-console-tucmall-tuorder-tuorder-module"
	],
	"../../panel/console/tucmall/tuorders/tuorders.module": [
		"./src/app/panel/console/tucmall/tuorders/tuorders.module.ts",
		"panel-console-tucmall-tuorders-tuorders-module"
	],
	"../../panel/console/tucmall/tuproducts/tuproducts.module": [
		"./src/app/panel/console/tucmall/tuproducts/tuproducts.module.ts",
		"panel-console-tucmall-tuproducts-tuproducts-module"
	],
	"../../panel/reports/tusale/tusale.module": [
		"./src/app/panel/reports/tusale/tusale.module.ts",
		"panel-reports-tusale-tusale-module"
	],
	"../../panel/smscampaign/Merchant/merchantsms/merchantsms.module": [
		"./src/app/panel/smscampaign/Merchant/merchantsms/merchantsms.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"panel-smscampaign-Merchant-merchantsms-merchantsms-module"
	],
	"../../panel/smscampaign/Merchant/tumerchantdetails/tumerchantdetails.module": [
		"./src/app/panel/smscampaign/Merchant/tumerchantdetails/tumerchantdetails.module.ts",
		"Merchant-tumerchantdetails-tumerchantdetails-module"
	],
	"../../panel/smscampaign/creditshistory/creditshistory.module": [
		"./src/app/panel/smscampaign/creditshistory/creditshistory.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"panel-smscampaign-creditshistory-creditshistory-module"
	],
	"../../panel/smscampaign/smsoverview/smsoverview.module": [
		"./src/app/panel/smscampaign/smsoverview/smsoverview.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"panel-smscampaign-smsoverview-smsoverview-module"
	],
	"../../panel/smscampaign/tuaddcampaign/tuaddcampaign.module": [
		"./src/app/panel/smscampaign/tuaddcampaign/tuaddcampaign.module.ts",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~bnpl-bnpl-module~bnploverview-bnploverview~75215596",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~bnpl-bnpl-module~bnploverview-bnploverview~de2dac75",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~modules-deals-tuadddeals-tuadddeals-module~b9019ce1",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~modules-deals-tuadddeals-tuadddeals-module~81cb151d",
		"default~account-bulkcustomerfiles-customerupload-module~account-tucustomers-tucustomers-module~merch~db57af3d",
		"panel-smscampaign-tuaddcampaign-tuaddcampaign-module"
	],
	"../../panel/smscampaign/tuallsmscampaign/tuallsmscampaign.module": [
		"./src/app/panel/smscampaign/tuallsmscampaign/tuallsmscampaign.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~bnpl-bnpl-module~bnploverview-bnploverview~75215596",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~bnpl-bnpl-module~bnploverview-bnploverview~de2dac75",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~modules-deals-tuadddeals-tuadddeals-module~b9019ce1",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~modules-deals-tuadddeals-tuadddeals-module~81cb151d",
		"panel-smscampaign-tuallsmscampaign-tuallsmscampaign-module"
	],
	"../../panel/smscampaign/tucampaigndetail/tucampaigndetail.module": [
		"./src/app/panel/smscampaign/tucampaigndetail/tucampaigndetail.module.ts",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~bnpl-bnpl-module~bnploverview-bnploverview~75215596",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~bnpl-bnpl-module~bnploverview-bnploverview~de2dac75",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~modules-deals-tuadddeals-tuadddeals-module~b9019ce1",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~modules-deals-tuadddeals-tuadddeals-module~81cb151d",
		"default~account-bulkcustomerfiles-customerupload-module~account-tucustomers-tucustomers-module~merch~db57af3d",
		"panel-smscampaign-tucampaigndetail-tucampaigndetail-module"
	],
	"../../panel/smscampaign/tumerchantdetails/tumerchantdetails.module": [
		"./src/app/panel/smscampaign/tumerchantdetails/tumerchantdetails.module.ts",
		"panel-smscampaign-tumerchantdetails-tumerchantdetails-module"
	],
	"../../panel/smscampaign/tusmscampaign/tusmscampaign.module": [
		"./src/app/panel/smscampaign/tusmscampaign/tusmscampaign.module.ts",
		"panel-smscampaign-tusmscampaign-tusmscampaign-module"
	],
	"../../panel/tuloan/tuloanactivity/tuloanactivity.module": [
		"./src/app/panel/tuloan/tuloanactivity/tuloanactivity.module.ts",
		"panel-tuloan-tuloanactivity-tuloanactivity-module"
	],
	"../../panel/tuloan/tuloanbase/tuloanbase.module": [
		"./src/app/panel/tuloan/tuloanbase/tuloanbase.module.ts",
		"panel-tuloan-tuloanbase-tuloanbase-module"
	],
	"../../panel/tuloan/tuloandetails/tuloandetails.module": [
		"./src/app/panel/tuloan/tuloandetails/tuloandetails.module.ts",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~bnpl-bnpl-module~bnploverview-bnploverview~75215596",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~modules-deals-tuadddeals-tuadddeals-module~b9019ce1",
		"default~panel-tuloan-tuloandetails-tuloandetails-module~panel-tuloan-tuloanrequests-tuloanrequests-m~20691d9a",
		"panel-tuloan-tuloandetails-tuloandetails-module"
	],
	"../../panel/tuloan/tuloanrequests/tuloanrequests.module": [
		"./src/app/panel/tuloan/tuloanrequests/tuloanrequests.module.ts",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~bnpl-bnpl-module~bnploverview-bnploverview~75215596",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~modules-deals-tuadddeals-tuadddeals-module~b9019ce1",
		"default~panel-tuloan-tuloandetails-tuloandetails-module~panel-tuloan-tuloanrequests-tuloanrequests-m~20691d9a"
	],
	"../../partner/account/tupartners/tupartners.module": [
		"./src/app/partner/account/tupartners/tupartners.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"partner-account-tupartners-tupartners-module"
	],
	"../../partner/accountcreation/tuaddpartner/tuaddpartner.module": [
		"./src/app/partner/accountcreation/tuaddpartner/tuaddpartner.module.ts",
		"default~Acquirer-BranchDivision-EditBranch-EditBranch-module~Acquirer-account-tustores-merchant-tust~edebb253",
		"partner-accountcreation-tuaddpartner-tuaddpartner-module"
	],
	"../../partner/accountdetails/tupartner/tupartner.module": [
		"./src/app/partner/accountdetails/tupartner/tupartner.module.ts",
		"partner-accountdetails-tupartner-tupartner-module"
	],
	"../../pssp/accountcreation/tuaddpssp/tuaddpssp.module": [
		"./src/app/pssp/accountcreation/tuaddpssp/tuaddpssp.module.ts",
		"default~Acquirer-BranchDivision-EditBranch-EditBranch-module~Acquirer-account-tustores-merchant-tust~edebb253",
		"pssp-accountcreation-tuaddpssp-tuaddpssp-module"
	],
	"../../pssp/accountdetails/tupssp/tupssp.module": [
		"./src/app/pssp/accountdetails/tupssp/tupssp.module.ts",
		"pssp-accountdetails-tupssp-tupssp-module"
	],
	"../../pssp/accounts/tupssps/tupssps.module": [
		"./src/app/pssp/accounts/tupssps/tupssps.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"pssp-accounts-tupssps-tupssps-module"
	],
	"../../ptsp/accountcreation/tuaddptsp/tuaddptsp.module": [
		"./src/app/ptsp/accountcreation/tuaddptsp/tuaddptsp.module.ts",
		"default~Acquirer-BranchDivision-EditBranch-EditBranch-module~Acquirer-account-tustores-merchant-tust~edebb253",
		"ptsp-accountcreation-tuaddptsp-tuaddptsp-module"
	],
	"../../ptsp/accountdetails/tuptsp/tuptsp.module": [
		"./src/app/ptsp/accountdetails/tuptsp/tuptsp.module.ts",
		"ptsp-accountdetails-tuptsp-tuptsp-module"
	],
	"../../ptsp/accounts/tuptsps/tuptsps.module": [
		"./src/app/ptsp/accounts/tuptsps/tuptsps.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"ptsp-accounts-tuptsps-tuptsps-module"
	],
	"../../transactions/tusale/redeemhistory/tusale.module": [
		"./src/app/Customer/modules/transactions/tusale/redeemhistory/tusale.module.ts",
		"transactions-tusale-redeemhistory-tusale-module"
	],
	"../../transactions/tusale/rewardhistory/tusale.module": [
		"./src/app/Customer/modules/transactions/tusale/rewardhistory/tusale.module.ts",
		"transactions-tusale-rewardhistory-tusale-module"
	],
	"../../transactions/tusale/tubuypoints/tubuypoints.module": [
		"./src/app/Customer/modules/transactions/tusale/tubuypoints/tubuypoints.module.ts",
		"transactions-tusale-tubuypoints-tubuypoints-module"
	],
	"../../transactions/tusale/tugiftcards/tugiftcards.module": [
		"./src/app/Customer/modules/transactions/tusale/tugiftcards/tugiftcards.module.ts",
		"default~Customer-modules-accountdetails-tucustomer-tucustomer-module~transactions-tusale-tugiftcards~a1dcb434",
		"transactions-tusale-tugiftcards-tugiftcards-module"
	],
	"../../transactions/tusale/tugiftpoints/tugiftpoints.module": [
		"./src/app/Customer/modules/transactions/tusale/tugiftpoints/tugiftpoints.module.ts",
		"transactions-tusale-tugiftpoints-tugiftpoints-module"
	],
	"../../transactions/tusale/tupayments/tupayments.module": [
		"./src/app/Customer/modules/transactions/tusale/tupayments/tupayments.module.ts",
		"transactions-tusale-tupayments-tupayments-module"
	],
	"../../transactions/tusale/turewardclaim/turewardclaim.module": [
		"./src/app/Customer/modules/transactions/tusale/turewardclaim/turewardclaim.module.ts",
		"transactions-tusale-turewardclaim-turewardclaim-module"
	],
	"../../transactions/tusale/tusale.module": [
		"./src/app/Customer/modules/transactions/tusale/tusale.module.ts",
		"transactions-tusale-tusale-module"
	],
	"../../transactions/vashistory/tusale.module": [
		"./src/app/Customer/modules/transactions/vashistory/tusale.module.ts",
		"transactions-vashistory-tusale-module"
	],
	"../../tureferal/tureferal.module": [
		"./src/app/tureferal/tureferal.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"tureferal-tureferal-module"
	],
	"../../tusettings/adminuser/passwordsecurity/passwordsecurity.module": [
		"./src/app/modules/acountsettings/tusettings/adminuser/passwordsecurity/passwordsecurity.module.ts",
		"tusettings-adminuser-passwordsecurity-passwordsecurity-module"
	],
	"../../tusettings/loginhistory/loginhistory.module": [
		"./src/app/modules/acountsettings/tusettings/loginhistory/loginhistory.module.ts",
		"tusettings-loginhistory-loginhistory-module"
	],
	"../Merchant/merchantcredits/merchantcredits.module": [
		"./src/app/panel/smscampaign/Merchant/merchantcredits/merchantcredits.module.ts",
		"merchantcredits-merchantcredits-module"
	],
	"../Merchant/merchantgroups/merchantgroups.module": [
		"./src/app/panel/smscampaign/Merchant/merchantgroups/merchantgroups.module.ts",
		"default~account-bulkcustomerfiles-customerupload-module~account-tucustomers-tucustomers-module~merch~db57af3d",
		"merchantgroups-merchantgroups-module"
	],
	"../Merchant/tumerchantdetails/tumerchantdetails.module": [
		"./src/app/panel/smscampaign/Merchant/tumerchantdetails/tumerchantdetails.module.ts",
		"Merchant-tumerchantdetails-tumerchantdetails-module"
	],
	"../bankloyaltymerchant/bankloyaltymerchant.module": [
		"./src/app/Acquirer/accountdetails/bankloyaltymerchant/bankloyaltymerchant.module.ts",
		"bankloyaltymerchant-bankloyaltymerchant-module"
	],
	"../bankloyaltyredeemtransaction/bankloyaltyredeemtransaction.module": [
		"./src/app/Acquirer/accountdetails/bankloyaltyredeemtransaction/bankloyaltyredeemtransaction.module.ts",
		"bankloyaltyredeemtransaction-bankloyaltyredeemtransaction-module"
	],
	"../bankloyaltyrewardtransaction/bankloyaltyrewardtransaction.module": [
		"./src/app/Acquirer/accountdetails/bankloyaltyrewardtransaction/bankloyaltyrewardtransaction.module.ts",
		"bankloyaltyrewardtransaction-bankloyaltyrewardtransaction-module"
	],
	"../bankloyaltytransaction/bankloyaltytransaction.module": [
		"./src/app/Acquirer/accountdetails/bankloyaltytransaction/bankloyaltytransaction.module.ts",
		"bankloyaltytransaction-bankloyaltytransaction-module"
	],
	"../credentials/credentials.module": [
		"./src/app/modules/acountsettings/tusettings/credentials/credentials.module.ts",
		"credentials-credentials-module"
	],
	"../cubnplconfiguration/cubnplconfiguration.module": [
		"./src/app/Customer/modules/accountdetails/tucustomer/cubnplconfiguration/cubnplconfiguration.module.ts",
		"cubnplconfiguration-cubnplconfiguration-module"
	],
	"../customercashout/customercashout.module": [
		"./src/app/Customer/modules/accountdetails/tucustomer/customercashout/customercashout.module.ts",
		"customercashout-customercashout-module"
	],
	"../customers/tuallcustomers/tuallcustomers.module": [
		"./src/app/Customer/modules/accounts/tucustomer/customers/tuallcustomers/tuallcustomers.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"customers-tuallcustomers-tuallcustomers-module"
	],
	"../customers/tuappdownloadscustomers/tuappdownloadscustomers.module": [
		"./src/app/Customer/modules/accounts/tucustomer/customers/tuappdownloadscustomers/tuappdownloadscustomers.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"customers-tuappdownloadscustomers-tuappdownloadscustomers-module"
	],
	"../customers/tumerchantcutomers/tumerchantcutomers.module": [
		"./src/app/Customer/modules/accounts/tucustomer/customers/tumerchantcutomers/tumerchantcutomers.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"customers-tumerchantcutomers-tumerchantcutomers-module"
	],
	"../customers/tutuccutomers/tutuccutomers.module": [
		"./src/app/Customer/modules/accounts/tucustomer/customers/tutuccutomers/tutuccutomers.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"customers-tutuccutomers-tutuccutomers-module"
	],
	"../customertrasactions/customertrasactions.module": [
		"./src/app/panel/accounts/tuwallethistory/customertrasactions/customertrasactions.module.ts",
		"customertrasactions-customertrasactions-module"
	],
	"../hcapps/tuapprequest/turequesthistory.module": [
		"./src/app/panel/administration/hcapps/tuapprequest/turequesthistory.module.ts",
		"hcapps-tuapprequest-turequesthistory-module"
	],
	"../loyaltybankoverview/loyaltybankoverview.module": [
		"./src/app/Acquirer/accountdetails/loyaltybankoverview/loyaltybankoverview.module.ts",
		"loyaltybankoverview-loyaltybankoverview-module"
	],
	"../merchant/giftcard/overview/tugiftcard.module": [
		"./src/app/merchant/giftcard/overview/tugiftcard.module.ts",
		"merchant-giftcard-overview-tugiftcard-module"
	],
	"../merchanttrasactions/merchanttrasactions.module": [
		"./src/app/panel/accounts/tuwallethistory/merchanttrasactions/merchanttrasactions.module.ts",
		"merchanttrasactions-merchanttrasactions-module"
	],
	"../tuairtime/tuairtime.module": [
		"./src/app/panel/accounts/tupayments/tuairtime/tuairtime.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"tuairtime-tuairtime-module"
	],
	"../tucustomer/tucustomerdetails/tucustomerdetails.module": [
		"./src/app/Customer/modules/accountdetails/tucustomer/tucustomerdetails/tucustomerdetails.module.ts",
		"tucustomer-tucustomerdetails-tucustomerdetails-module"
	],
	"../tudeal/tuanalytics/tuanalytics.module": [
		"./src/app/panel/console/deals/tudeal/tuanalytics/tuanalytics.module.ts",
		"tudeal-tuanalytics-tuanalytics-module"
	],
	"../tudeal/tunotifhistory/tunotifhistory.module": [
		"./src/app/panel/console/deals/tudeal/tunotifhistory/tunotifhistory.module.ts",
		"tudeal-tunotifhistory-tunotifhistory-module"
	],
	"../tudeal/turedeemhistory/turedeemhistory.module": [
		"./src/app/panel/console/deals/tudeal/turedeemhistory/turedeemhistory.module.ts",
		"tudeal-turedeemhistory-turedeemhistory-module"
	],
	"../tudeal/tusoldhistory/tusoldhistory.module": [
		"./src/app/panel/console/deals/tudeal/tusoldhistory/tusoldhistory.module.ts",
		"tudeal-tusoldhistory-tusoldhistory-module"
	],
	"../tuelectricity/tuelectricity.module": [
		"./src/app/panel/accounts/tupayments/tuelectricity/tuelectricity.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"tuelectricity-tuelectricity-module"
	],
	"../tuloanactivity/tucreditdefault/tucreditdefault.module": [
		"./src/app/panel/tuloan/tuloanactivity/tucreditdefault/tucreditdefault.module.ts",
		"tuloanactivity-tucreditdefault-tucreditdefault-module"
	],
	"../tuloanactivity/tucreditloan/tucreditloan.module": [
		"./src/app/panel/tuloan/tuloanactivity/tucreditloan/tucreditloan.module.ts",
		"tuloanactivity-tucreditloan-tucreditloan-module"
	],
	"../tuloanactivity/tuloanactive/tuloanactive.module": [
		"./src/app/panel/tuloan/tuloanactivity/tuloanactive/tuloanactive.module.ts",
		"tuloanactivity-tuloanactive-tuloanactive-module"
	],
	"../tuloanactivity/tuloanall/tuloanall.module": [
		"./src/app/panel/tuloan/tuloanactivity/tuloanall/tuloanall.module.ts",
		"tuloanactivity-tuloanall-tuloanall-module"
	],
	"../tuloanactivity/tuloanfailed/tuloanfailed.module": [
		"./src/app/panel/tuloan/tuloanactivity/tuloanfailed/tuloanfailed.module.ts",
		"tuloanactivity-tuloanfailed-tuloanfailed-module"
	],
	"../tuloanactivity/tuloanprocessing/tuloanprocessing.module": [
		"./src/app/panel/tuloan/tuloanactivity/tuloanprocessing/tuloanprocessing.module.ts",
		"tuloanactivity-tuloanprocessing-tuloanprocessing-module"
	],
	"../tuloanactivity/tuloanrejected/tuloanrejected.module": [
		"./src/app/panel/tuloan/tuloanactivity/tuloanrejected/tuloanrejected.module.ts",
		"tuloanactivity-tuloanrejected-tuloanrejected-module"
	],
	"../tuloanoveredue/tuloanoveredue.module": [
		"./src/app/panel/tuloan/tuloanoveredue/tuloanoveredue.module.ts",
		"tuloanoveredue-tuloanoveredue-module"
	],
	"../tuloanpaid/tuloanpaid.module": [
		"./src/app/panel/tuloan/tuloanpaid/tuloanpaid.module.ts",
		"tuloanpaid-tuloanpaid-module"
	],
	"../tumerchant/tumerchantdetails/tumerchantdetails.module": [
		"./src/app/modules/accountdetails/tuconsole/tumerchant/tumerchantdetails/tumerchantdetails.module.ts",
		"default~accounts-tuconsole-rewardpercentage-turewardpercentage-module~tumerchant-tumerchantdetails-t~5b0b1961",
		"tumerchant-tumerchantdetails-tumerchantdetails-module"
	],
	"../tupickups/tucancelledpickups/tucancelledpickup.module": [
		"./src/app/panel/console/deals/tupickups/tucancelledpickups/tucancelledpickup.module.ts",
		"tupickups-tucancelledpickups-tucancelledpickup-module"
	],
	"../tupickups/tupendingpickup/tupendingpickup.module": [
		"./src/app/panel/console/deals/tupickups/tupendingpickup/tupendingpickup.module.ts",
		"tupickups-tupendingpickup-tupendingpickup-module"
	],
	"../tupickups/tureturnpickups/tureturnpickup.module": [
		"./src/app/panel/console/deals/tupickups/tureturnpickups/tureturnpickup.module.ts",
		"tupickups-tureturnpickups-tureturnpickup-module"
	],
	"../tusettings/adminroles/adminroles.module": [
		"./src/app/modules/acountsettings/tusettings/adminroles/adminroles.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"tusettings-adminroles-adminroles-module"
	],
	"../tusettings/adminusers/adminusers.module": [
		"./src/app/modules/acountsettings/tusettings/adminusers/adminusers.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"tusettings-adminusers-adminusers-module"
	],
	"../tusettings/credentials/credentials.module": [
		"./src/app/modules/acountsettings/tusettings/credentials/credentials.module.ts",
		"credentials-credentials-module"
	],
	"../tusmscampaign/smsoverview/smsoverview.module": [
		"./src/app/panel/smscampaign/tusmscampaign/smsoverview/smsoverview.module.ts",
		"tusmscampaign-smsoverview-smsoverview-module"
	],
	"../tutollgate/tutollgate.module": [
		"./src/app/panel/accounts/tupayments/tutollgate/tutollgate.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"tutollgate-tutollgate-module"
	],
	"../tutvrechanrge/tutvrechanrge.module": [
		"./src/app/panel/accounts/tupayments/tutvrechanrge/tutvrechanrge.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"tutvrechanrge-tutvrechanrge-module"
	],
	"../tuvasproduct/tutransactions/tupayments.module": [
		"./src/app/panel/accounts/tupayments/tuvasproduct/tutransactions/tupayments.module.ts",
		"tuvasproduct-tutransactions-tupayments-module"
	],
	"../tuvasproduct/tuvaspackages/tuvaspackages.module": [
		"./src/app/panel/accounts/tupayments/tuvasproduct/tuvaspackages/tuvaspackages.module.ts",
		"tuvasproduct-tuvaspackages-tuvaspackages-module"
	],
	"../userprofile/editprofile/editprofile.module": [
		"./src/app/modules/acountsettings/tusettings/userprofile/editprofile/editprofile.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"default~panels-console-console-module~userprofile-editprofile-editprofile-module",
		"userprofile-editprofile-editprofile-module"
	],
	"./../../pages/dashboard/tumerchantterminallive/tumerchantterminallive.module": [
		"./src/app/pages/dashboard/tumerchantterminallive/tumerchantterminallive.module.ts",
		"pages-dashboard-tumerchantterminallive-tumerchantterminallive-module"
	],
	"./../../pages/hcmerchantedit/hcmerchantedit.module": [
		"./src/app/pages/hcmerchantedit/hcmerchantedit.module.ts",
		"default~Acquirer-BranchDivision-EditBranch-EditBranch-module~Acquirer-account-tustores-merchant-tust~edebb253",
		"pages-hcmerchantedit-hcmerchantedit-module"
	],
	"./../../pages/useronboarding/bulkmerchant/merchantupload.module": [
		"./src/app/pages/useronboarding/bulkmerchant/merchantupload.module.ts",
		"default~account-bulkcustomerfiles-customerupload-module~account-tucustomers-tucustomers-module~merch~db57af3d",
		"pages-useronboarding-bulkmerchant-merchantupload-module"
	],
	"./../../panel/console/dashboards/root/dashboard.module": [
		"./src/app/panel/console/dashboards/root/dashboard.module.ts",
		"default~panel-accounts-tupayments-tuvasanalytics-tuvasanalytics-module~panel-console-analytics-tuove~b0048449",
		"panel-console-dashboards-root-dashboard-module"
	],
	"./../Merchant/smsoverview/smsoverview.module": [
		"./src/app/panel/smscampaign/Merchant/smsoverview/smsoverview.module.ts",
		"Merchant-smsoverview-smsoverview-module"
	],
	"./../Merchant/tuallsmscampaign/tuallsmscampaign.module": [
		"./src/app/panel/smscampaign/Merchant/tuallsmscampaign/tuallsmscampaign.module.ts",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~bnpl-bnpl-module~bnploverview-bnploverview~75215596",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~bnpl-bnpl-module~bnploverview-bnploverview~de2dac75",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~modules-deals-tuadddeals-tuadddeals-module~b9019ce1",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~modules-deals-tuadddeals-tuadddeals-module~81cb151d",
		"Merchant-tuallsmscampaign-tuallsmscampaign-module"
	],
	"./../merchantcredits/merchantcredits.module": [
		"./src/app/panel/smscampaign/Merchant/merchantcredits/merchantcredits.module.ts",
		"merchantcredits-merchantcredits-module"
	],
	"./../merchantgroups/merchantgroups.module": [
		"./src/app/panel/smscampaign/Merchant/merchantgroups/merchantgroups.module.ts",
		"default~account-bulkcustomerfiles-customerupload-module~account-tucustomers-tucustomers-module~merch~db57af3d",
		"merchantgroups-merchantgroups-module"
	],
	"./../tusmscampaign/allcutomers/allcutomers.module": [
		"./src/app/panel/smscampaign/tusmscampaign/allcutomers/allcutomers.module.ts",
		"tusmscampaign-allcutomers-allcutomers-module"
	],
	"./bnplmerchants/bnplmerchants.module": [
		"./src/app/bnpl/bnplmerchants/bnplmerchants.module.ts",
		"default~bnpl-bnpl-module~bnplmerchants-bnplmerchants-module~panels-console-console-module"
	],
	"./bnploverview/bnploverview.module": [
		"./src/app/bnpl/bnploverview/bnploverview.module.ts",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~bnpl-bnpl-module~bnploverview-bnploverview~75215596",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~bnpl-bnpl-module~bnploverview-bnploverview~de2dac75",
		"default~bnpl-bnpl-module~bnploverview-bnploverview-module~panels-console-console-module"
	],
	"./giftcards/listgiftcards.module": [
		"./src/app/gift-card/giftcards/listgiftcards.module.ts",
		"giftcards-listgiftcards-module"
	],
	"./invoicesandreports/invoicesandreports.module": [
		"./src/app/bnpl/invoicesandreports/invoicesandreports.module.ts",
		"default~bnpl-bnpl-module~invoicesandreports-invoicesandreports-module~panels-console-console-module"
	],
	"./merchantsettlements/merchantsettlements.module": [
		"./src/app/bnpl/merchantsettlements/merchantsettlements.module.ts",
		"default~bnpl-bnpl-module~merchantsettlements-merchantsettlements-module~panels-console-console-modul~d36a67a7"
	],
	"./panels/console/console.module": [
		"./src/app/panels/console/console.module.ts",
		"default~Acquirer-account-tuacquirers-tuacquirers-module~Acquirer-accountdetails-tumanager-acquirer-t~dd3ad7e6",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~bnpl-bnpl-module~bnploverview-bnploverview~75215596",
		"default~Merchant-tuallsmscampaign-tuallsmscampaign-module~bnpl-bnpl-module~bnploverview-bnploverview~de2dac75",
		"default~bnpl-bnpl-module~panel-accounts-tuinvoices-invoicedetails-invoicedetails-module~panel-consol~db3b6e14",
		"default~bnpl-bnpl-module~merchantsettlements-merchantsettlements-module~panels-console-console-modul~d36a67a7",
		"default~bnpl-bnpl-module~bnploverview-bnploverview-module~panels-console-console-module",
		"default~bnpl-bnpl-module~bnplmerchants-bnplmerchants-module~panels-console-console-module",
		"default~bnpl-bnpl-module~invoicesandreports-invoicesandreports-module~panels-console-console-module",
		"default~panels-console-console-module~userprofile-editprofile-editprofile-module",
		"default~bnpl-bnpl-module~panels-console-console-module",
		"panels-console-console-module"
	],
	"./redeemindividual/tucredeemhistory.module": [
		"./src/app/gift-card/redeemindividual/tucredeemhistory.module.ts",
		"redeemindividual-tucredeemhistory-module"
	],
	"./transactions/tucgctransactions.module": [
		"./src/app/gift-card/transactions/tucgctransactions.module.ts",
		"transactions-tucgctransactions-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;